var an = Object.defineProperty;
var rn = (t, e, a) => e in t ? an(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var Me = (t, e, a) => (rn(t, typeof e != "symbol" ? e + "" : e, a), a);
import { jsx as x, jsxs as Y } from "react/jsx-runtime";
import L, { createContext as Ie, Component as nn, createElement as _e, useRef as on, useCallback as sn, forwardRef as ar, useState as Pr, Suspense as dn, useEffect as ln } from "react";
import * as un from "@tanstack/react-query";
import { useSuspenseInfiniteQuery as mn, dehydrate as fn, hydrate as cn, QueryClientProvider as vn, QueryErrorResetBoundary as hn, QueryClient as pn } from "@tanstack/react-query";
import { I18nextProvider as gn, useTranslation as yn } from "react-i18next";
import "i18next";
const bn = Ie(null), Be = {
  didCatch: !1,
  error: null
};
class Mn extends nn {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Be;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var a, r, n = arguments.length, o = new Array(n), d = 0; d < n; d++)
        o[d] = arguments[d];
      (a = (r = this.props).onReset) === null || a === void 0 || a.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(Be);
    }
  }
  componentDidCatch(e, a) {
    var r, n;
    (r = (n = this.props).onError) === null || r === void 0 || r.call(n, e, a);
  }
  componentDidUpdate(e, a) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (r && a.error !== null && _n(e.resetKeys, n)) {
      var o, d;
      (o = (d = this.props).onReset) === null || o === void 0 || o.call(d, {
        next: n,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(Be);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: a,
      FallbackComponent: r,
      fallback: n
    } = this.props, {
      didCatch: o,
      error: d
    } = this.state;
    let s = e;
    if (o) {
      const i = {
        error: d,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof a == "function")
        s = a(i);
      else if (r)
        s = _e(r, i);
      else if (n !== void 0)
        s = n;
      else
        throw d;
    }
    return _e(bn.Provider, {
      value: {
        didCatch: o,
        error: d,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function _n() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((a, r) => !Object.is(a, e[r]));
}
var wn = /* @__PURE__ */ Ie({}), Cr = "id";
function xn(t) {
  return t === void 0 && (t = Cr), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Pn = /* @__PURE__ */ Ie(xn);
function Cn(t) {
  var e = t.children, a = t.prefix, r = a === void 0 ? Cr : a, n = on(0), o = sn(function(d) {
    return d === void 0 && (d = r), (d ? d + "-" : "") + ++n.current;
  }, [r]);
  return /* @__PURE__ */ _e(Pn.Provider, {
    value: o
  }, e);
}
function En(t) {
  var e = t.children, a = t.unstable_system;
  return /* @__PURE__ */ _e(wn.Provider, {
    value: a
  }, e);
}
var kn = {};
function Dn(t) {
  var e = t.unstable_prefix, a = t.unstable_system, r = a === void 0 ? kn : a, n = t.children;
  return /* @__PURE__ */ _e(Cn, {
    prefix: e
  }, /* @__PURE__ */ _e(En, {
    unstable_system: r
  }, n));
}
const Tn = ({ children: t, i18nInstance: e }) => /* @__PURE__ */ x(gn, { i18n: e, children: t }), On = (t = "label") => {
  const e = Array.isArray(t) ? t : [t];
  return yn(e);
}, Nn = () => {
  const { t } = On("label");
  return /* @__PURE__ */ x("div", { "data-testid": "default-loading-fallback", children: t("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
var Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function X(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const Sn = "application/json", Er = "Content-Type", je = Symbol(), kr = Symbol();
function rr(t = {}) {
  var e;
  const a = t instanceof Array ? Object.fromEntries(t) : t;
  return (e = Object.entries(a).find(([r]) => r.toLowerCase() === Er.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function nr(t) {
  return /^application\/.*json.*/.test(t);
}
const ke = function(t, e, a = !1) {
  return Object.entries(e).reduce((r, [n, o]) => {
    const d = t[n];
    return Array.isArray(d) && Array.isArray(o) ? r[n] = a ? [...d, ...o] : o : typeof d == "object" && typeof o == "object" ? r[n] = ke(d, o, a) : r[n] = o, r;
  }, { ...t });
}, Re = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, a = !1, ...r) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return a && n ? new n(...r) : n;
  }
};
function jn(t, e = !1) {
  Re.options = e ? t : ke(Re.options, t);
}
function Wn(t, e = !1) {
  Re.polyfills = e ? t : ke(Re.polyfills, t);
}
function Rn(t) {
  Re.errorType = t;
}
const Ln = (t) => (e) => t.reduceRight((a, r) => r(a), e) || e;
class Dr extends Error {
}
const zn = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((m, f) => f.beforeRequest && f.beforeRequest(m, t._options, e) || m, t);
  const { _url: a, _options: r, _config: n, _catchers: o, _resolvers: d, _middlewares: s, _addons: i } = t, l = new Map(o), u = ke(n.options, r);
  let v = a;
  const b = Ln(s)((m, f) => (v = m, n.polyfill("fetch")(m, f)))(a, u), g = new Error(), y = b.catch((m) => {
    throw { [je]: m };
  }).then((m) => {
    var f;
    if (!m.ok) {
      const M = new Dr();
      if (M.cause = g, M.stack = M.stack + `
CAUSE: ` + g.stack, M.response = m, M.status = m.status, M.url = v, m.type === "opaque")
        throw M;
      const P = n.errorType === "json" || ((f = m.headers.get("Content-Type")) === null || f === void 0 ? void 0 : f.split(";")[0]) === "application/json";
      return (n.errorType ? P ? m.text() : m[n.errorType]() : Promise.resolve(m.body)).then((I) => {
        throw M.message = typeof I == "string" ? I : m.statusText, I && (P && typeof I == "string" ? (M.text = I, M.json = JSON.parse(I)) : M[n.errorType] = I), M;
      });
    }
    return m;
  }), _ = (m) => m.catch((f) => {
    const M = Object.prototype.hasOwnProperty.call(f, je), P = M ? f[je] : f, O = (P == null ? void 0 : P.status) && l.get(P.status) || l.get(P == null ? void 0 : P.name) || M && l.has(je) && l.get(je);
    if (O)
      return O(P, t);
    const I = l.get(kr);
    if (I)
      return I(P, t);
    throw P;
  }), p = (m) => (f) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ _(m ? y.then((M) => M && M[m]()).then((M) => f ? f(M) : M) : y.then((M) => f ? f(M) : M)), c = {
    _wretchReq: t,
    _fetchReq: b,
    _sharedState: e,
    res: p(null),
    json: p("json"),
    blob: p("blob"),
    formData: p("formData"),
    arrayBuffer: p("arrayBuffer"),
    text: p("text"),
    error(m, f) {
      return l.set(m, f), this;
    },
    badRequest(m) {
      return this.error(400, m);
    },
    unauthorized(m) {
      return this.error(401, m);
    },
    forbidden(m) {
      return this.error(403, m);
    },
    notFound(m) {
      return this.error(404, m);
    },
    timeout(m) {
      return this.error(408, m);
    },
    internalError(m) {
      return this.error(500, m);
    },
    fetchError(m) {
      return this.error(je, m);
    }
  }, h = i.reduce((m, f) => ({
    ...m,
    ...typeof f.resolver == "function" ? f.resolver(m) : f.resolver
  }), c);
  return d.reduce((m, f) => f(m, t), h);
}, An = {
  _url: "",
  _options: {},
  _config: Re,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : ke(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const a = this._url.split("?");
    return {
      ...this,
      _url: a.length > 1 ? a[0] + t + "?" + a[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : ke(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: ke(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [Er]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const a = new Map(this._catchers);
    return a.set(t, e), { ...this, _catchers: a };
  },
  catcherFallback(t) {
    return this.catcher(kr, t);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", a = null) {
    let r = this.url(e).options({ method: t });
    const n = rr(r._options.headers), o = this._config.polyfill("FormData", !1), d = typeof a == "object" && !(o && a instanceof o) && (!r._options.headers || !n || nr(n));
    return r = a ? d ? r.json(a, n) : r.body(a) : r, zn(r._deferred.reduce((s, i) => i(s, s._url, s._options), r));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const a = rr(this._options.headers);
    return this.content(e || nr(a) && a || Sn).body(JSON.stringify(t));
  }
};
function we(t = "", e = {}) {
  return { ...An, _url: t, _options: e };
}
we.default = we;
we.options = jn;
we.errorType = Rn;
we.polyfills = Wn;
we.WretchError = Dr;
class Hn extends Error {
  constructor(a, r, n, o, d) {
    super(a);
    Me(this, "statusCode");
    Me(this, "endpoint");
    Me(this, "args");
    Me(this, "response");
    this.name = "ApiError", this.statusCode = r, this.endpoint = n, this.args = o, this.response = d;
  }
}
class Ga extends Hn {
  constructor(e, a, r, n) {
    super(`Client error ${e} occurred while fetching ${a}`, e, a, r, n), this.name = "Api4xxError";
  }
}
class Fn extends Ga {
  constructor(e, a, r) {
    super(404, e, a, r), this.name = "Api404Error";
  }
}
class $n extends Ga {
  constructor(e, a, r) {
    super(400, e, a, r), this.name = "Api400Error";
  }
}
class qn {
  constructor(e = {}) {
    Me(this, "logger");
    Me(this, "notFoundLogLevel");
    Me(this, "badRequestLogLevel");
    Me(this, "other4xxLogLevel");
    this.logger = e.logger, this.notFoundLogLevel = e.notFoundLogLevel || "info", this.badRequestLogLevel = e.badRequestLogLevel || "warn", this.other4xxLogLevel = e.other4xxLogLevel || "warn";
  }
  log(e, a, r) {
    this.logger && this.logger[e](a, r);
  }
  async handleApiError(e, a, r) {
    if (!(e instanceof Response))
      throw e;
    const { status: n } = e;
    if (n === 404) {
      const o = new Fn(a, r, e);
      return this.log(this.notFoundLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new $n(a, r, e);
      return this.log(this.badRequestLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new Ga(n, a, r, e);
      return this.log(this.other4xxLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    throw e;
  }
}
const In = (t, e) => {
  const a = new qn(e);
  return t.catcher(404, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(400, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(401, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(403, async (r) => (await a.handleApiError(r.response, r.url), null)).catcherFallback(async (r) => {
    if (r.status >= 400 && r.status < 500)
      return await a.handleApiError(r.response, r.url), null;
    throw r;
  });
};
/*! js-cookie v3.0.5 | MIT */
function $e(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e];
    for (var r in a)
      t[r] = a[r];
  }
  return t;
}
var Un = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function et(t, e) {
  function a(n, o, d) {
    if (!(typeof document > "u")) {
      d = $e({}, e, d), typeof d.expires == "number" && (d.expires = new Date(Date.now() + d.expires * 864e5)), d.expires && (d.expires = d.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var i in d)
        d[i] && (s += "; " + i, d[i] !== !0 && (s += "=" + d[i].split(";")[0]));
      return document.cookie = n + "=" + t.write(o, n) + s;
    }
  }
  function r(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], d = {}, s = 0; s < o.length; s++) {
        var i = o[s].split("="), l = i.slice(1).join("=");
        try {
          var u = decodeURIComponent(i[0]);
          if (d[u] = t.read(l, u), n === u)
            break;
        } catch {
        }
      }
      return n ? d[n] : d;
    }
  }
  return Object.create(
    {
      set: a,
      get: r,
      remove: function(n, o) {
        a(
          n,
          "",
          $e({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return et(this.converter, $e({}, this.attributes, n));
      },
      withConverter: function(n) {
        return et($e({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
et(Un, { path: "/" });
Ie({});
const Tr = (t) => {
  typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
    ...t
  }));
}, Or = {
  ARTICLE_CLICK: "article_click",
  HERO_ARTICLE_VIEW: "hero_article_view"
}, Yn = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx`, Nr = (t, e) => {
  const a = new URL(t);
  return a.searchParams.set("fm", "webp"), a.searchParams.set("w", e.toString()), a.toString();
}, Bn = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function ze(t, e) {
  if (!e && typeof window > "u")
    return t;
  try {
    const a = new URL(e || window.location.href), r = new URLSearchParams(a.search), n = [];
    for (const s of Bn) {
      const i = r.get(s);
      i !== null && n.push([s, i]);
    }
    if (n.length === 0)
      return t;
    const o = t.startsWith("http://") || t.startsWith("https://"), d = o ? new URL(t) : new URL(t, a.origin);
    for (const [s, i] of n)
      d.searchParams.has(s) || d.searchParams.set(s, i);
    return o ? d.toString() : d.pathname + d.search + d.hash;
  } catch {
    return t;
  }
}
const Sr = async (t = Yn(), e, a) => {
  const { countryCode: r, limit: n, offset: o, repub: d, subdivision: s, topics: i, type: l } = e, u = new URL(`${t}/v2/articles`);
  return l && u.searchParams.append("articleType", l), n && u.searchParams.append("limit", n.toString()), o && u.searchParams.append("offset", o.toString()), i && u.searchParams.append("topics", i), In(
    we(u.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "country-code": r,
        repub: d,
        ...s ? { subdivision: s } : {},
        ...(a == null ? void 0 : a.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    a
  ).get().notFound(() => null).json();
}, jr = ({
  countryCode: t,
  limit: e,
  repub: a,
  subdivision: r,
  topics: n,
  type: o
}) => ["more-articles", a, t, r, n, o, e];
var Xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Wr(t) {
  var e, a, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var n = t.length;
      for (e = 0; e < n; e++)
        t[e] && (a = Wr(t[e])) && (r && (r += " "), r += a);
    } else
      for (a in t)
        t[a] && (r && (r += " "), r += a);
  return r;
}
function G() {
  for (var t, e, a = 0, r = "", n = arguments.length; a < n; a++)
    (t = arguments[a]) && (e = Wr(t)) && (r && (r += " "), r += e);
  return r;
}
const or = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, ir = G, Jn = (t, e) => (a) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return ir(t, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
  const { variants: n, defaultVariants: o } = e, d = Object.keys(n).map((l) => {
    const u = a == null ? void 0 : a[l], v = o == null ? void 0 : o[l];
    if (u === null)
      return null;
    const b = or(u) || or(v);
    return n[l][b];
  }), s = a && Object.entries(a).reduce((l, u) => {
    let [v, b] = u;
    return b === void 0 || (l[v] = b), l;
  }, {}), i = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, u) => {
    let { class: v, className: b, ...g } = u;
    return Object.entries(g).every((y) => {
      let [_, p] = y;
      return Array.isArray(p) ? p.includes({
        ...o,
        ...s
      }[_]) : {
        ...o,
        ...s
      }[_] === p;
    }) ? [
      ...l,
      v,
      b
    ] : l;
  }, []);
  return ir(t, d, i, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
}, Qn = "_icon_1tv3o_1", me = {
  icon: Qn,
  "size--xs": "_size--xs_1tv3o_5",
  "size--s": "_size--s_1tv3o_10",
  "size--m": "_size--m_1tv3o_15",
  "size--l": "_size--l_1tv3o_20",
  "size--xl": "_size--xl_1tv3o_25",
  "color--black": "_color--black_1tv3o_30",
  "color--white": "_color--white_1tv3o_34",
  "color--green": "_color--green_1tv3o_38",
  "color--blue": "_color--blue_1tv3o_42",
  "color--grey": "_color--grey_1tv3o_46"
}, ne = Jn(me.icon, {
  variants: {
    color: {
      black: me["color--black"],
      white: me["color--white"],
      blue: me["color--blue"],
      green: me["color--green"],
      grey: me["color--grey"]
    },
    size: {
      xs: me["size--xs"],
      s: me["size--s"],
      m: me["size--m"],
      l: me["size--l"],
      xl: me["size--xl"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "m"
  }
}), Zn = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 11, fill: "none", viewBox: "0 0 12 11", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "m.136 5.702 4.091 4.772c.178.249.546.248.773.045a.56.56 0 0 0 .045-.781L1.747 5.895h9.707c.301 0 .546-.251.546-.561s-.244-.561-.546-.561H1.747L5.045.93c.216-.215.156-.584-.071-.788s-.569-.189-.747.051L.136 4.965A.56.56 0 0 0 0 5.334c.01.119.059.279.136.368",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Zn.displayName = "Arrow";
const Gn = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M16.5 1.838v14.999a.46.46 0 0 1-.248.413l-.18.046a.45.45 0 0 1-.316-.115l-1.735-1.631-.225.207v3.767a.46.46 0 0 1-.271.413l-.18.046a.45.45 0 0 1-.316-.115l-1.713-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.78-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.758-1.631-1.735 1.631a.44.44 0 0 1-.487.097.46.46 0 0 1-.279-.418V4.548c0-1.015.807-1.838 1.803-1.838h.901v-.873C3.204.823 4.011 0 5.007 0h9.69c.996 0 1.803.823 1.803 1.838m-4.868 15.458 1.262 1.195V4.525a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v13.966l1.284-1.195a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.444.444 0 0 1 .609 0zm2.682-2.71 1.284 1.194-.023-13.943a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v.85h7.887c.996 0 1.803.823 1.803 1.838v9.992a.445.445 0 0 1 .541.069M4.976 8h3.048c.263 0 .476-.224.476-.5S8.287 7 8.024 7H4.976c-.263 0-.476.224-.476.5s.213.5.476.5m-.06 2h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0 3h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5z",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
Gn.displayName = "Betslip";
const tt = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 9, fill: "none", viewBox: "0 0 13 9", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
tt.displayName = "ChevronDown";
const Kn = L.forwardRef(
  ({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
    const d = G(
      ne({
        color: t,
        size: e
      }),
      r
    ), s = {
      "--opacity": a
    };
    return L.cloneElement(
      /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ Y("g", { fill: "currentColor", children: [
        /* @__PURE__ */ x("path", { d: "M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" }),
        /* @__PURE__ */ x("path", { d: "M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" })
      ] }) }),
      {
        role: "presentation",
        focusable: !1,
        className: d,
        "aria-hidden": !0,
        style: s,
        ...n
      }
    );
  }
);
Kn.displayName = "ChevronDownLight";
const eo = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 8, fill: "none", viewBox: "0 0 13 8", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
eo.displayName = "ChevronUp";
const to = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ Y("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none", viewBox: "0 0 13 13", ref: o, ...n, children: [
      /* @__PURE__ */ x("path", { fill: "currentColor", d: "M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" }),
      /* @__PURE__ */ x("path", { fill: "currentColor", d: "M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
to.displayName = "Cross";
const ao = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M15.344 17.778a.75.75 0 0 0-.75-.75h-5.16a.75.75 0 1 0 0 1.5h5.16a.75.75 0 0 0 .75-.75m2.206-4a.75.75 0 0 0-.75-.75H7.204a.75.75 0 1 0 0 1.5H16.8a.75.75 0 0 0 .75-.75m2.45-4a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 .75-.75m2-4a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h18.5a.75.75 0 0 0 .75-.75"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
ao.displayName = "Filter";
const ro = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", viewBox: "0 0 15 15", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 13.5a6 6 0 0 0 4.243-1.757A6 6 0 0 0 13.5 7.5a6 6 0 0 0-1.757-4.243A6 6 0 0 0 7.5 1.5a6 6 0 0 0-6 6 6 6 0 0 0 6 6m0 1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3h1.5v1.5h-1.5z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
ro.displayName = "Info";
const no = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M1.423 0a.923.923 0 1 0 0 1.846h14.154a.923.923 0 1 0 0-1.846zM.5 7.692c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423A.923.923 0 0 1 .5 7.692m0 6.769c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423a.923.923 0 0 1-.923-.923",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
no.displayName = "Menu";
const oo = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ Y(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 19 18",
        ref: o,
        ...n,
        children: [
          /* @__PURE__ */ x("path", { d: "m6.361 11.888.359-.84a.4.4 0 0 1 .229-.222.4.4 0 0 1 .125-.022q.098 0 .185.049c.546.306 1.279.49 1.961.49.801 0 1.383-.345 1.383-.818 0-.306-.169-.676-1.415-1.102-1.35-.446-2.725-1.097-2.725-2.557 0-1.108.767-1.975 2.052-2.317l.195-.052v-.916c0-.224.177-.408.39-.408h.923a.4.4 0 0 1 .39.408v.823l.229.03a4.6 4.6 0 0 1 1.482.432c.094.047.166.129.2.232s.031.216-.013.312l-.372.829a.39.39 0 0 1-.354.235.4.4 0 0 1-.161-.038c-.242-.118-.809-.388-1.714-.388-.822 0-1.188.334-1.188.667 0 .372.382.624 1.578 1.039 1.274.438 2.575 1.097 2.575 2.683 0 .856-.564 2.008-2.156 2.429l-.195.055v.949c0 .227-.177.41-.39.41h-.939a.4.4 0 0 1-.39-.41V13l-.231-.025c-.718-.085-1.394-.29-1.849-.566a.42.42 0 0 1-.163-.522z" }),
          /* @__PURE__ */ x(
            "path",
            {
              d: "M18.228 8.727a8.73 8.73 0 0 1-8.727 8.727A8.73 8.73 0 0 1 .773 8.727 8.73 8.73 0 0 1 9.501 0a8.73 8.73 0 0 1 8.727 8.727m-1.091 0c0 4.382-3.255 7.636-7.636 7.636s-7.636-3.255-7.636-7.636S5.12 1.091 9.501 1.091s7.636 3.255 7.636 7.636",
              fillRule: "evenodd"
            }
          )
        ]
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
oo.displayName = "Offers";
const io = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ Y("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: [
      /* @__PURE__ */ x(
        "path",
        {
          stroke: "currentColor",
          d: "M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
        }
      ),
      /* @__PURE__ */ x("path", { stroke: "currentColor", d: "M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
io.displayName = "Padlock";
const so = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 20, fill: "none", viewBox: "0 0 12 20", ref: o, ...n, children: /* @__PURE__ */ x("path", { stroke: "currentColor", d: "M4.9 11.119H1L8.8 1 6.85 8.738h3.9l-7.8 10.119z", strokeLinejoin: "round" }) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
so.displayName = "Picks";
const lo = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", viewBox: "0 0 19 19", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "M9.048.949a.5.5 0 0 1 .903 0l2.45 5.151a.5.5 0 0 0 .387.281l5.656.738a.5.5 0 0 1 .279.859L14.581 11.9a.5.5 0 0 0-.148.455l1.046 5.607a.5.5 0 0 1-.731.531l-5.009-2.727a.5.5 0 0 0-.478 0l-5.009 2.727a.5.5 0 0 1-.731-.531l1.046-5.607a.5.5 0 0 0-.148-.455L.277 7.978a.5.5 0 0 1 .279-.859l5.656-.738a.5.5 0 0 0 .387-.281z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
lo.displayName = "Star";
const uo = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 20, fill: "none", viewBox: "0 0 22 20", ref: o, ...n, children: /* @__PURE__ */ x(
      "path",
      {
        stroke: "currentColor",
        d: "M15.965 4.968c0 2.372-2.081 4.368-4.743 4.368S6.478 7.34 6.478 4.968 8.56.6 11.222.6s4.743 1.996 4.743 4.368ZM15.318 10.857c.174-.116.314-.182.435-.205 1.448-.273 2.575.594 3.49 2.15.906 1.543 1.472 3.573 1.799 5.122.16.758-.429 1.476-1.275 1.476H1.863c-.75 0-1.265-.556-1.207-1.185.222-2.425 1.23-6.34 5.288-7.684.275-.091.607-.059.935.095 1.852.867 3.42 1.291 4.805 1.31 1.4.02 2.577-.374 3.634-1.079Z",
        strokeWidth: 1.2
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
uo.displayName = "Account";
const mo = L.forwardRef(({ color: t, size: e, opacity: a = 1, className: r, ...n }, o) => {
  const d = G(
    ne({
      color: t,
      size: e
    }),
    r
  ), s = {
    "--opacity": a
  };
  return L.cloneElement(
    /* @__PURE__ */ x(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.78,
        height: 9.58,
        fill: "none",
        viewBox: "0 0 12.78 9.58",
        ref: o,
        ...n,
        children: /* @__PURE__ */ x("path", { fill: "currentColor", d: "m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" })
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: d,
      "aria-hidden": !0,
      style: s,
      ...n
    }
  );
});
mo.displayName = "Check";
var Rr = { exports: {} };
(function(t, e) {
  (function(a, r) {
    t.exports = r(L);
  })(Xn, (a) => (() => {
    var r = { 703: (s, i, l) => {
      var u = l(414);
      function v() {
      }
      function b() {
      }
      b.resetWarningCache = v, s.exports = function() {
        function g(p, c, h, m, f, M) {
          if (M !== u) {
            var P = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw P.name = "Invariant Violation", P;
          }
        }
        function y() {
          return g;
        }
        g.isRequired = g;
        var _ = { array: g, bigint: g, bool: g, func: g, number: g, object: g, string: g, symbol: g, any: g, arrayOf: y, element: g, elementType: g, instanceOf: y, node: g, objectOf: y, oneOf: y, oneOfType: y, shape: y, exact: y, checkPropTypes: b, resetWarningCache: v };
        return _.PropTypes = _, _;
      };
    }, 697: (s, i, l) => {
      s.exports = l(703)();
    }, 414: (s) => {
      s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, 98: (s) => {
      s.exports = a;
    } }, n = {};
    function o(s) {
      var i = n[s];
      if (i !== void 0)
        return i.exports;
      var l = n[s] = { exports: {} };
      return r[s](l, l.exports, o), l.exports;
    }
    o.n = (s) => {
      var i = s && s.__esModule ? () => s.default : () => s;
      return o.d(i, { a: i }), i;
    }, o.d = (s, i) => {
      for (var l in i)
        o.o(i, l) && !o.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: i[l] });
    }, o.o = (s, i) => Object.prototype.hasOwnProperty.call(s, i), o.r = (s) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
    };
    var d = {};
    return (() => {
      o.r(d), o.d(d, { default: () => Ee });
      var s = o(98), i = o.n(s), l = o(697), u = o.n(l);
      function v() {
        return v = Object.assign ? Object.assign.bind() : function(D) {
          for (var E = 1; E < arguments.length; E++) {
            var S = arguments[E];
            for (var j in S)
              Object.prototype.hasOwnProperty.call(S, j) && (D[j] = S[j]);
          }
          return D;
        }, v.apply(this, arguments);
      }
      var b = function(D) {
        var E = D.pageClassName, S = D.pageLinkClassName, j = D.page, te = D.selected, B = D.activeClassName, V = D.activeLinkClassName, k = D.getEventListener, w = D.pageSelectedHandler, R = D.href, T = D.extraAriaContext, N = D.pageLabelBuilder, W = D.rel, H = D.ariaLabel || "Page " + j + (T ? " " + T : ""), J = null;
        return te && (J = "page", H = D.ariaLabel || "Page " + j + " is your current page", E = E !== void 0 ? E + " " + B : B, S !== void 0 ? V !== void 0 && (S = S + " " + V) : S = V), i().createElement("li", { className: E }, i().createElement("a", v({ rel: W, role: R ? void 0 : "button", className: S, href: R, tabIndex: te ? "-1" : "0", "aria-label": H, "aria-current": J, onKeyPress: w }, k(w)), N(j)));
      };
      b.propTypes = { pageSelectedHandler: u().func.isRequired, selected: u().bool.isRequired, pageClassName: u().string, pageLinkClassName: u().string, activeClassName: u().string, activeLinkClassName: u().string, extraAriaContext: u().string, href: u().string, ariaLabel: u().string, page: u().number.isRequired, getEventListener: u().func.isRequired, pageLabelBuilder: u().func.isRequired, rel: u().string };
      const g = b;
      function y() {
        return y = Object.assign ? Object.assign.bind() : function(D) {
          for (var E = 1; E < arguments.length; E++) {
            var S = arguments[E];
            for (var j in S)
              Object.prototype.hasOwnProperty.call(S, j) && (D[j] = S[j]);
          }
          return D;
        }, y.apply(this, arguments);
      }
      var _ = function(D) {
        var E = D.breakLabel, S = D.breakAriaLabel, j = D.breakClassName, te = D.breakLinkClassName, B = D.breakHandler, V = D.getEventListener, k = j || "break";
        return i().createElement("li", { className: k }, i().createElement("a", y({ className: te, role: "button", tabIndex: "0", "aria-label": S, onKeyPress: B }, V(B)), E));
      };
      _.propTypes = { breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabel: u().string, breakClassName: u().string, breakLinkClassName: u().string, breakHandler: u().func.isRequired, getEventListener: u().func.isRequired };
      const p = _;
      function c(D) {
        var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return D ?? E;
      }
      function h(D) {
        return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
          return typeof E;
        } : function(E) {
          return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
        }, h(D);
      }
      function m() {
        return m = Object.assign ? Object.assign.bind() : function(D) {
          for (var E = 1; E < arguments.length; E++) {
            var S = arguments[E];
            for (var j in S)
              Object.prototype.hasOwnProperty.call(S, j) && (D[j] = S[j]);
          }
          return D;
        }, m.apply(this, arguments);
      }
      function f(D, E) {
        for (var S = 0; S < E.length; S++) {
          var j = E[S];
          j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(D, j.key, j);
        }
      }
      function M(D, E) {
        return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(S, j) {
          return S.__proto__ = j, S;
        }, M(D, E);
      }
      function P(D, E) {
        if (E && (h(E) === "object" || typeof E == "function"))
          return E;
        if (E !== void 0)
          throw new TypeError("Derived constructors may only return object or undefined");
        return O(D);
      }
      function O(D) {
        if (D === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return D;
      }
      function I(D) {
        return I = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(E) {
          return E.__proto__ || Object.getPrototypeOf(E);
        }, I(D);
      }
      function z(D, E, S) {
        return E in D ? Object.defineProperty(D, E, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : D[E] = S, D;
      }
      var le = function(D) {
        (function(k, w) {
          if (typeof w != "function" && w !== null)
            throw new TypeError("Super expression must either be null or a function");
          k.prototype = Object.create(w && w.prototype, { constructor: { value: k, writable: !0, configurable: !0 } }), Object.defineProperty(k, "prototype", { writable: !1 }), w && M(k, w);
        })(V, D);
        var E, S, j, te, B = (j = V, te = function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }(), function() {
          var k, w = I(j);
          if (te) {
            var R = I(this).constructor;
            k = Reflect.construct(w, arguments, R);
          } else
            k = w.apply(this, arguments);
          return P(this, k);
        });
        function V(k) {
          var w, R;
          return function(T, N) {
            if (!(T instanceof N))
              throw new TypeError("Cannot call a class as a function");
          }(this, V), z(O(w = B.call(this, k)), "handlePreviousPage", function(T) {
            var N = w.state.selected;
            w.handleClick(T, null, N > 0 ? N - 1 : void 0, { isPrevious: !0 });
          }), z(O(w), "handleNextPage", function(T) {
            var N = w.state.selected, W = w.props.pageCount;
            w.handleClick(T, null, N < W - 1 ? N + 1 : void 0, { isNext: !0 });
          }), z(O(w), "handlePageSelected", function(T, N) {
            if (w.state.selected === T)
              return w.callActiveCallback(T), void w.handleClick(N, null, void 0, { isActive: !0 });
            w.handleClick(N, null, T);
          }), z(O(w), "handlePageChange", function(T) {
            w.state.selected !== T && (w.setState({ selected: T }), w.callCallback(T));
          }), z(O(w), "getEventListener", function(T) {
            return z({}, w.props.eventListener, T);
          }), z(O(w), "handleClick", function(T, N, W) {
            var H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, J = H.isPrevious, Z = J !== void 0 && J, de = H.isNext, be = de !== void 0 && de, ue = H.isBreak, Q = ue !== void 0 && ue, fe = H.isActive, ce = fe !== void 0 && fe;
            T.preventDefault ? T.preventDefault() : T.returnValue = !1;
            var ve = w.state.selected, q = w.props.onClick, A = W;
            if (q) {
              var U = q({ index: N, selected: ve, nextSelectedPage: W, event: T, isPrevious: Z, isNext: be, isBreak: Q, isActive: ce });
              if (U === !1)
                return;
              Number.isInteger(U) && (A = U);
            }
            A !== void 0 && w.handlePageChange(A);
          }), z(O(w), "handleBreakClick", function(T, N) {
            var W = w.state.selected;
            w.handleClick(N, T, W < T ? w.getForwardJump() : w.getBackwardJump(), { isBreak: !0 });
          }), z(O(w), "callCallback", function(T) {
            w.props.onPageChange !== void 0 && typeof w.props.onPageChange == "function" && w.props.onPageChange({ selected: T });
          }), z(O(w), "callActiveCallback", function(T) {
            w.props.onPageActive !== void 0 && typeof w.props.onPageActive == "function" && w.props.onPageActive({ selected: T });
          }), z(O(w), "getElementPageRel", function(T) {
            var N = w.state.selected, W = w.props, H = W.nextPageRel, J = W.prevPageRel, Z = W.selectedPageRel;
            return N - 1 === T ? J : N === T ? Z : N + 1 === T ? H : void 0;
          }), z(O(w), "pagination", function() {
            var T = [], N = w.props, W = N.pageRangeDisplayed, H = N.pageCount, J = N.marginPagesDisplayed, Z = N.breakLabel, de = N.breakClassName, be = N.breakLinkClassName, ue = N.breakAriaLabels, Q = w.state.selected;
            if (H <= W)
              for (var fe = 0; fe < H; fe++)
                T.push(w.getPageElement(fe));
            else {
              var ce = W / 2, ve = W - ce;
              Q > H - W / 2 ? ce = W - (ve = H - Q) : Q < W / 2 && (ve = W - (ce = Q));
              var q, A, U = function(xe) {
                return w.getPageElement(xe);
              }, F = [];
              for (q = 0; q < H; q++) {
                var He = q + 1;
                if (He <= J)
                  F.push({ type: "page", index: q, display: U(q) });
                else if (He > H - J)
                  F.push({ type: "page", index: q, display: U(q) });
                else if (q >= Q - ce && q <= Q + (Q === 0 && W > 1 ? ve - 1 : ve))
                  F.push({ type: "page", index: q, display: U(q) });
                else if (Z && F.length > 0 && F[F.length - 1].display !== A && (W > 0 || J > 0)) {
                  var Ye = q < Q ? ue.backward : ue.forward;
                  A = i().createElement(p, { key: q, breakAriaLabel: Ye, breakLabel: Z, breakClassName: de, breakLinkClassName: be, breakHandler: w.handleBreakClick.bind(null, q), getEventListener: w.getEventListener }), F.push({ type: "break", index: q, display: A });
                }
              }
              F.forEach(function(xe, Pe) {
                var Fe = xe;
                xe.type === "break" && F[Pe - 1] && F[Pe - 1].type === "page" && F[Pe + 1] && F[Pe + 1].type === "page" && F[Pe + 1].index - F[Pe - 1].index <= 2 && (Fe = { type: "page", index: xe.index, display: U(xe.index) }), T.push(Fe.display);
              });
            }
            return T;
          }), k.initialPage !== void 0 && k.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(k.initialPage, ") and forcePage (").concat(k.forcePage, ") props are provided, which is discouraged.") + ` Use exclusively forcePage prop for a controlled component.
See https://reactjs.org/docs/forms.html#controlled-components`), R = k.initialPage ? k.initialPage : k.forcePage ? k.forcePage : 0, w.state = { selected: R }, w;
        }
        return E = V, (S = [{ key: "componentDidMount", value: function() {
          var k = this.props, w = k.initialPage, R = k.disableInitialCallback, T = k.extraAriaContext, N = k.pageCount, W = k.forcePage;
          w === void 0 || R || this.callCallback(w), T && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(N) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(N, "). Did you forget a Math.ceil()?")), w !== void 0 && w > N - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(w, " > ").concat(N - 1, ").")), W !== void 0 && W > N - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(W, " > ").concat(N - 1, ")."));
        } }, { key: "componentDidUpdate", value: function(k) {
          this.props.forcePage !== void 0 && this.props.forcePage !== k.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({ selected: this.props.forcePage })), Number.isInteger(k.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
        } }, { key: "getForwardJump", value: function() {
          var k = this.state.selected, w = this.props, R = w.pageCount, T = k + w.pageRangeDisplayed;
          return T >= R ? R - 1 : T;
        } }, { key: "getBackwardJump", value: function() {
          var k = this.state.selected - this.props.pageRangeDisplayed;
          return k < 0 ? 0 : k;
        } }, { key: "getElementHref", value: function(k) {
          var w = this.props, R = w.hrefBuilder, T = w.pageCount, N = w.hrefAllControls;
          if (R)
            return N || k >= 0 && k < T ? R(k + 1, T, this.state.selected) : void 0;
        } }, { key: "ariaLabelBuilder", value: function(k) {
          var w = k === this.state.selected;
          if (this.props.ariaLabelBuilder && k >= 0 && k < this.props.pageCount) {
            var R = this.props.ariaLabelBuilder(k + 1, w);
            return this.props.extraAriaContext && !w && (R = R + " " + this.props.extraAriaContext), R;
          }
        } }, { key: "getPageElement", value: function(k) {
          var w = this.state.selected, R = this.props, T = R.pageClassName, N = R.pageLinkClassName, W = R.activeClassName, H = R.activeLinkClassName, J = R.extraAriaContext, Z = R.pageLabelBuilder;
          return i().createElement(g, { key: k, pageSelectedHandler: this.handlePageSelected.bind(null, k), selected: w === k, rel: this.getElementPageRel(k), pageClassName: T, pageLinkClassName: N, activeClassName: W, activeLinkClassName: H, extraAriaContext: J, href: this.getElementHref(k), ariaLabel: this.ariaLabelBuilder(k), page: k + 1, pageLabelBuilder: Z, getEventListener: this.getEventListener });
        } }, { key: "render", value: function() {
          var k = this.props.renderOnZeroPageCount;
          if (this.props.pageCount === 0 && k !== void 0)
            return k && k(this.props);
          var w = this.props, R = w.disabledClassName, T = w.disabledLinkClassName, N = w.pageCount, W = w.className, H = w.containerClassName, J = w.previousLabel, Z = w.previousClassName, de = w.previousLinkClassName, be = w.previousAriaLabel, ue = w.prevRel, Q = w.nextLabel, fe = w.nextClassName, ce = w.nextLinkClassName, ve = w.nextAriaLabel, q = w.nextRel, A = this.state.selected, U = A === 0, F = A === N - 1, He = "".concat(c(Z)).concat(U ? " ".concat(c(R)) : ""), Ye = "".concat(c(fe)).concat(F ? " ".concat(c(R)) : ""), xe = "".concat(c(de)).concat(U ? " ".concat(c(T)) : ""), Pe = "".concat(c(ce)).concat(F ? " ".concat(c(T)) : ""), Fe = U ? "true" : "false", tn = F ? "true" : "false";
          return i().createElement("ul", { className: W || H, role: "navigation", "aria-label": "Pagination" }, i().createElement("li", { className: He }, i().createElement("a", m({ className: xe, href: this.getElementHref(A - 1), tabIndex: U ? "-1" : "0", role: "button", onKeyPress: this.handlePreviousPage, "aria-disabled": Fe, "aria-label": be, rel: ue }, this.getEventListener(this.handlePreviousPage)), J)), this.pagination(), i().createElement("li", { className: Ye }, i().createElement("a", m({ className: Pe, href: this.getElementHref(A + 1), tabIndex: F ? "-1" : "0", role: "button", onKeyPress: this.handleNextPage, "aria-disabled": tn, "aria-label": ve, rel: q }, this.getEventListener(this.handleNextPage)), Q)));
        } }]) && f(E.prototype, S), Object.defineProperty(E, "prototype", { writable: !1 }), V;
      }(s.Component);
      z(le, "propTypes", { pageCount: u().number.isRequired, pageRangeDisplayed: u().number, marginPagesDisplayed: u().number, previousLabel: u().node, previousAriaLabel: u().string, prevPageRel: u().string, prevRel: u().string, nextLabel: u().node, nextAriaLabel: u().string, nextPageRel: u().string, nextRel: u().string, breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabels: u().shape({ forward: u().string, backward: u().string }), hrefBuilder: u().func, hrefAllControls: u().bool, onPageChange: u().func, onPageActive: u().func, onClick: u().func, initialPage: u().number, forcePage: u().number, disableInitialCallback: u().bool, containerClassName: u().string, className: u().string, pageClassName: u().string, pageLinkClassName: u().string, pageLabelBuilder: u().func, activeClassName: u().string, activeLinkClassName: u().string, previousClassName: u().string, nextClassName: u().string, previousLinkClassName: u().string, nextLinkClassName: u().string, disabledClassName: u().string, disabledLinkClassName: u().string, breakClassName: u().string, breakLinkClassName: u().string, extraAriaContext: u().string, ariaLabelBuilder: u().func, eventListener: u().string, renderOnZeroPageCount: u().func, selectedPageRel: u().string }), z(le, "defaultProps", { pageRangeDisplayed: 2, marginPagesDisplayed: 3, activeClassName: "selected", previousLabel: "Previous", previousClassName: "previous", previousAriaLabel: "Previous page", prevPageRel: "prev", prevRel: "prev", nextLabel: "Next", nextClassName: "next", nextAriaLabel: "Next page", nextPageRel: "next", nextRel: "next", breakLabel: "...", breakAriaLabels: { forward: "Jump forward", backward: "Jump backward" }, disabledClassName: "disabled", disableInitialCallback: !1, pageLabelBuilder: function(D) {
        return D;
      }, eventListener: "onClick", renderOnZeroPageCount: void 0, selectedPageRel: "canonical", hrefAllControls: !1 });
      const Ee = le;
    })(), d;
  })());
})(Rr);
var fo = Rr.exports;
const co = /* @__PURE__ */ Vn(fo), vo = "_Pagination_1oamq_64", ho = "_paginationContainer_1oamq_68", po = "_pageItem_1oamq_74", go = "_pageItemDisabled_1oamq_96", yo = "_active_1oamq_118", bo = "_breakEllipsis_1oamq_122", Mo = "_previousIcon_1oamq_144", _o = "_nextIcon_1oamq_148", wo = "_labelWrapper_1oamq_152", xo = "_labelText_1oamq_158", ae = {
  Pagination: vo,
  paginationContainer: ho,
  pageItem: po,
  pageItemDisabled: go,
  active: yo,
  breakEllipsis: bo,
  previousIcon: Mo,
  nextIcon: _o,
  labelWrapper: wo,
  labelText: xo
}, Po = ({
  forcePage: t,
  pageCount: e,
  onPageChange: a,
  hrefBuilder: r,
  previousLabel: n,
  nextLabel: o,
  ...d
}) => {
  const s = typeof t == "number" ? t + 1 : 1, i = s === 1, l = s === e, u = i ? ae.pageItemDisabled : ae.pageItem, v = i ? "grey" : "black", b = l ? ae.pageItemDisabled : ae.pageItem, g = l ? "grey" : "black";
  return /* @__PURE__ */ x("div", { className: ae.Pagination, "data-testid": "pagination", children: /* @__PURE__ */ x(
    co,
    {
      forcePage: t,
      pageCount: e,
      onPageChange: a,
      containerClassName: ae.paginationContainer,
      pageClassName: ae.pageItem,
      previousClassName: u,
      nextClassName: b,
      activeClassName: ae.active,
      breakClassName: ae.breakEllipsis,
      previousLabel: /* @__PURE__ */ Y("div", { className: ae.labelWrapper, "data-testid": "previous-page-button", children: [
        /* @__PURE__ */ x(tt, { className: ae.previousIcon, color: v, size: "xs" }),
        n ? /* @__PURE__ */ x("span", { className: ae.labelText, children: n }) : null
      ] }),
      nextLabel: /* @__PURE__ */ Y("div", { className: ae.labelWrapper, "data-testid": "next-page-button", children: [
        o ? /* @__PURE__ */ x("span", { className: ae.labelText, children: o }) : null,
        /* @__PURE__ */ x(tt, { className: ae.nextIcon, color: g, size: "xs" })
      ] }),
      marginPagesDisplayed: 1,
      pageRangeDisplayed: 2,
      renderOnZeroPageCount: null,
      pageLinkClassName: "page-link",
      hrefBuilder: r,
      ...d
    }
  ) });
};
var at = { exports: {} }, Lr = { exports: {} };
(function(t) {
  function e(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Lr);
var C = Lr.exports, rt = { exports: {} }, nt = { exports: {} }, zr = { exports: {} };
(function(t) {
  function e(a) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(a);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(zr);
var Ar = zr.exports, ot = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r, n) {
    if (n.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  t.exports = e.default;
})(ot, ot.exports);
var K = ot.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a(Ar), n = a(K);
  function o(d) {
    return (0, n.default)(1, arguments), d instanceof Date || (0, r.default)(d) === "object" && Object.prototype.toString.call(d) === "[object Date]";
  }
  t.exports = e.default;
})(nt, nt.exports);
var Co = nt.exports, it = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a(Ar), n = a(K);
  function o(d) {
    (0, n.default)(1, arguments);
    var s = Object.prototype.toString.call(d);
    return d instanceof Date || (0, r.default)(d) === "object" && s === "[object Date]" ? new Date(d.getTime()) : typeof d == "number" || s === "[object Number]" ? new Date(d) : ((typeof d == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(it, it.exports);
var he = it.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(Co), n = a(he), o = a(K);
  function d(s) {
    if ((0, o.default)(1, arguments), !(0, r.default)(s) && typeof s != "number")
      return !1;
    var i = (0, n.default)(s);
    return !isNaN(Number(i));
  }
  t.exports = e.default;
})(rt, rt.exports);
var Eo = rt.exports, st = { exports: {} }, dt = { exports: {} }, lt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var n = Number(r);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  t.exports = e.default;
})(lt, lt.exports);
var De = lt.exports;
const ko = /* @__PURE__ */ X(De);
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(De), n = a(he), o = a(K);
  function d(s, i) {
    (0, o.default)(2, arguments);
    var l = (0, n.default)(s).getTime(), u = (0, r.default)(i);
    return new Date(l + u);
  }
  t.exports = e.default;
})(dt, dt.exports);
var Do = dt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(Do), n = a(K), o = a(De);
  function d(s, i) {
    (0, n.default)(2, arguments);
    var l = (0, o.default)(i);
    return (0, r.default)(s, -l);
  }
  t.exports = e.default;
})(st, st.exports);
var To = st.exports, ut = { exports: {} }, mt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(he), n = a(K), o = 864e5;
  function d(s) {
    (0, n.default)(1, arguments);
    var i = (0, r.default)(s), l = i.getTime();
    i.setUTCMonth(0, 1), i.setUTCHours(0, 0, 0, 0);
    var u = i.getTime(), v = l - u;
    return Math.floor(v / o) + 1;
  }
  t.exports = e.default;
})(mt, mt.exports);
var Oo = mt.exports, ft = { exports: {} }, ct = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a(he), n = a(K);
  function o(d) {
    (0, n.default)(1, arguments);
    var s = 1, i = (0, r.default)(d), l = i.getUTCDay(), u = (l < s ? 7 : 0) + l - s;
    return i.setUTCDate(i.getUTCDate() - u), i.setUTCHours(0, 0, 0, 0), i;
  }
  t.exports = e.default;
})(ct, ct.exports);
var Ka = ct.exports, vt = { exports: {} }, ht = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(he), n = a(K), o = a(Ka);
  function d(s) {
    (0, n.default)(1, arguments);
    var i = (0, r.default)(s), l = i.getUTCFullYear(), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(l + 1, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var v = (0, o.default)(u), b = /* @__PURE__ */ new Date(0);
    b.setUTCFullYear(l, 0, 4), b.setUTCHours(0, 0, 0, 0);
    var g = (0, o.default)(b);
    return i.getTime() >= v.getTime() ? l + 1 : i.getTime() >= g.getTime() ? l : l - 1;
  }
  t.exports = e.default;
})(ht, ht.exports);
var Hr = ht.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = d;
  var r = a(Hr), n = a(Ka), o = a(K);
  function d(s) {
    (0, o.default)(1, arguments);
    var i = (0, r.default)(s), l = /* @__PURE__ */ new Date(0);
    l.setUTCFullYear(i, 0, 4), l.setUTCHours(0, 0, 0, 0);
    var u = (0, n.default)(l);
    return u;
  }
  t.exports = e.default;
})(vt, vt.exports);
var No = vt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = a(he), n = a(Ka), o = a(No), d = a(K), s = 6048e5;
  function i(l) {
    (0, d.default)(1, arguments);
    var u = (0, r.default)(l), v = (0, n.default)(u).getTime() - (0, o.default)(u).getTime();
    return Math.round(v / s) + 1;
  }
  t.exports = e.default;
})(ft, ft.exports);
var So = ft.exports, pt = { exports: {} }, gt = { exports: {} }, Te = {};
Object.defineProperty(Te, "__esModule", {
  value: !0
});
Te.getDefaultOptions = jo;
Te.setDefaultOptions = Wo;
var Fr = {};
function jo() {
  return Fr;
}
function Wo(t) {
  Fr = t;
}
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var r = a(he), n = a(K), o = a(De), d = Te;
  function s(i, l) {
    var u, v, b, g, y, _, p, c;
    (0, n.default)(1, arguments);
    var h = (0, d.getDefaultOptions)(), m = (0, o.default)((u = (v = (b = (g = l == null ? void 0 : l.weekStartsOn) !== null && g !== void 0 ? g : l == null || (y = l.locale) === null || y === void 0 || (_ = y.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && b !== void 0 ? b : h.weekStartsOn) !== null && v !== void 0 ? v : (p = h.locale) === null || p === void 0 || (c = p.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && u !== void 0 ? u : 0);
    if (!(m >= 0 && m <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var f = (0, r.default)(i), M = f.getUTCDay(), P = (M < m ? 7 : 0) + M - m;
    return f.setUTCDate(f.getUTCDate() - P), f.setUTCHours(0, 0, 0, 0), f;
  }
  t.exports = e.default;
})(gt, gt.exports);
var Ue = gt.exports, yt = { exports: {} }, bt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = a(he), n = a(K), o = a(Ue), d = a(De), s = Te;
  function i(l, u) {
    var v, b, g, y, _, p, c, h;
    (0, n.default)(1, arguments);
    var m = (0, r.default)(l), f = m.getUTCFullYear(), M = (0, s.getDefaultOptions)(), P = (0, d.default)((v = (b = (g = (y = u == null ? void 0 : u.firstWeekContainsDate) !== null && y !== void 0 ? y : u == null || (_ = u.locale) === null || _ === void 0 || (p = _.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && g !== void 0 ? g : M.firstWeekContainsDate) !== null && b !== void 0 ? b : (c = M.locale) === null || c === void 0 || (h = c.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && v !== void 0 ? v : 1);
    if (!(P >= 1 && P <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var O = /* @__PURE__ */ new Date(0);
    O.setUTCFullYear(f + 1, 0, P), O.setUTCHours(0, 0, 0, 0);
    var I = (0, o.default)(O, u), z = /* @__PURE__ */ new Date(0);
    z.setUTCFullYear(f, 0, P), z.setUTCHours(0, 0, 0, 0);
    var le = (0, o.default)(z, u);
    return m.getTime() >= I.getTime() ? f + 1 : m.getTime() >= le.getTime() ? f : f - 1;
  }
  t.exports = e.default;
})(bt, bt.exports);
var $r = bt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = a($r), n = a(K), o = a(Ue), d = a(De), s = Te;
  function i(l, u) {
    var v, b, g, y, _, p, c, h;
    (0, n.default)(1, arguments);
    var m = (0, s.getDefaultOptions)(), f = (0, d.default)((v = (b = (g = (y = u == null ? void 0 : u.firstWeekContainsDate) !== null && y !== void 0 ? y : u == null || (_ = u.locale) === null || _ === void 0 || (p = _.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && g !== void 0 ? g : m.firstWeekContainsDate) !== null && b !== void 0 ? b : (c = m.locale) === null || c === void 0 || (h = c.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && v !== void 0 ? v : 1), M = (0, r.default)(l, u), P = /* @__PURE__ */ new Date(0);
    P.setUTCFullYear(M, 0, f), P.setUTCHours(0, 0, 0, 0);
    var O = (0, o.default)(P, u);
    return O;
  }
  t.exports = e.default;
})(yt, yt.exports);
var Ro = yt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var r = a(he), n = a(Ue), o = a(Ro), d = a(K), s = 6048e5;
  function i(l, u) {
    (0, d.default)(1, arguments);
    var v = (0, r.default)(l), b = (0, n.default)(v, u).getTime() - (0, o.default)(v, u).getTime();
    return Math.round(b / s) + 1;
  }
  t.exports = e.default;
})(pt, pt.exports);
var Lo = pt.exports, Mt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r, n) {
    for (var o = r < 0 ? "-" : "", d = Math.abs(r).toString(); d.length < n; )
      d = "0" + d;
    return o + d;
  }
  t.exports = e.default;
})(Mt, Mt.exports);
var qr = Mt.exports, _t = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(qr), n = {
    // Year
    y: function(s, i) {
      var l = s.getUTCFullYear(), u = l > 0 ? l : 1 - l;
      return (0, r.default)(i === "yy" ? u % 100 : u, i.length);
    },
    // Month
    M: function(s, i) {
      var l = s.getUTCMonth();
      return i === "M" ? String(l + 1) : (0, r.default)(l + 1, 2);
    },
    // Day of the month
    d: function(s, i) {
      return (0, r.default)(s.getUTCDate(), i.length);
    },
    // AM or PM
    a: function(s, i) {
      var l = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (i) {
        case "a":
        case "aa":
          return l.toUpperCase();
        case "aaa":
          return l;
        case "aaaaa":
          return l[0];
        case "aaaa":
        default:
          return l === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(s, i) {
      return (0, r.default)(s.getUTCHours() % 12 || 12, i.length);
    },
    // Hour [0-23]
    H: function(s, i) {
      return (0, r.default)(s.getUTCHours(), i.length);
    },
    // Minute
    m: function(s, i) {
      return (0, r.default)(s.getUTCMinutes(), i.length);
    },
    // Second
    s: function(s, i) {
      return (0, r.default)(s.getUTCSeconds(), i.length);
    },
    // Fraction of second
    S: function(s, i) {
      var l = i.length, u = s.getUTCMilliseconds(), v = Math.floor(u * Math.pow(10, l - 3));
      return (0, r.default)(v, i.length);
    }
  }, o = n;
  e.default = o, t.exports = e.default;
})(_t, _t.exports);
var zo = _t.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Oo), n = a(So), o = a(Hr), d = a(Lo), s = a($r), i = a(qr), l = a(zo), u = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, v = {
    // Era
    G: function(c, h, m) {
      var f = c.getUTCFullYear() > 0 ? 1 : 0;
      switch (h) {
        case "G":
        case "GG":
        case "GGG":
          return m.era(f, {
            width: "abbreviated"
          });
        case "GGGGG":
          return m.era(f, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return m.era(f, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(c, h, m) {
      if (h === "yo") {
        var f = c.getUTCFullYear(), M = f > 0 ? f : 1 - f;
        return m.ordinalNumber(M, {
          unit: "year"
        });
      }
      return l.default.y(c, h);
    },
    // Local week-numbering year
    Y: function(c, h, m, f) {
      var M = (0, s.default)(c, f), P = M > 0 ? M : 1 - M;
      if (h === "YY") {
        var O = P % 100;
        return (0, i.default)(O, 2);
      }
      return h === "Yo" ? m.ordinalNumber(P, {
        unit: "year"
      }) : (0, i.default)(P, h.length);
    },
    // ISO week-numbering year
    R: function(c, h) {
      var m = (0, o.default)(c);
      return (0, i.default)(m, h.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(c, h) {
      var m = c.getUTCFullYear();
      return (0, i.default)(m, h.length);
    },
    // Quarter
    Q: function(c, h, m) {
      var f = Math.ceil((c.getUTCMonth() + 1) / 3);
      switch (h) {
        case "Q":
          return String(f);
        case "QQ":
          return (0, i.default)(f, 2);
        case "Qo":
          return m.ordinalNumber(f, {
            unit: "quarter"
          });
        case "QQQ":
          return m.quarter(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return m.quarter(f, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return m.quarter(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(c, h, m) {
      var f = Math.ceil((c.getUTCMonth() + 1) / 3);
      switch (h) {
        case "q":
          return String(f);
        case "qq":
          return (0, i.default)(f, 2);
        case "qo":
          return m.ordinalNumber(f, {
            unit: "quarter"
          });
        case "qqq":
          return m.quarter(f, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return m.quarter(f, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return m.quarter(f, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(c, h, m) {
      var f = c.getUTCMonth();
      switch (h) {
        case "M":
        case "MM":
          return l.default.M(c, h);
        case "Mo":
          return m.ordinalNumber(f + 1, {
            unit: "month"
          });
        case "MMM":
          return m.month(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return m.month(f, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return m.month(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(c, h, m) {
      var f = c.getUTCMonth();
      switch (h) {
        case "L":
          return String(f + 1);
        case "LL":
          return (0, i.default)(f + 1, 2);
        case "Lo":
          return m.ordinalNumber(f + 1, {
            unit: "month"
          });
        case "LLL":
          return m.month(f, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return m.month(f, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return m.month(f, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(c, h, m, f) {
      var M = (0, d.default)(c, f);
      return h === "wo" ? m.ordinalNumber(M, {
        unit: "week"
      }) : (0, i.default)(M, h.length);
    },
    // ISO week of year
    I: function(c, h, m) {
      var f = (0, n.default)(c);
      return h === "Io" ? m.ordinalNumber(f, {
        unit: "week"
      }) : (0, i.default)(f, h.length);
    },
    // Day of the month
    d: function(c, h, m) {
      return h === "do" ? m.ordinalNumber(c.getUTCDate(), {
        unit: "date"
      }) : l.default.d(c, h);
    },
    // Day of year
    D: function(c, h, m) {
      var f = (0, r.default)(c);
      return h === "Do" ? m.ordinalNumber(f, {
        unit: "dayOfYear"
      }) : (0, i.default)(f, h.length);
    },
    // Day of week
    E: function(c, h, m) {
      var f = c.getUTCDay();
      switch (h) {
        case "E":
        case "EE":
        case "EEE":
          return m.day(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return m.day(f, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return m.day(f, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return m.day(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(c, h, m, f) {
      var M = c.getUTCDay(), P = (M - f.weekStartsOn + 8) % 7 || 7;
      switch (h) {
        case "e":
          return String(P);
        case "ee":
          return (0, i.default)(P, 2);
        case "eo":
          return m.ordinalNumber(P, {
            unit: "day"
          });
        case "eee":
          return m.day(M, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return m.day(M, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return m.day(M, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return m.day(M, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(c, h, m, f) {
      var M = c.getUTCDay(), P = (M - f.weekStartsOn + 8) % 7 || 7;
      switch (h) {
        case "c":
          return String(P);
        case "cc":
          return (0, i.default)(P, h.length);
        case "co":
          return m.ordinalNumber(P, {
            unit: "day"
          });
        case "ccc":
          return m.day(M, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return m.day(M, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return m.day(M, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return m.day(M, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(c, h, m) {
      var f = c.getUTCDay(), M = f === 0 ? 7 : f;
      switch (h) {
        case "i":
          return String(M);
        case "ii":
          return (0, i.default)(M, h.length);
        case "io":
          return m.ordinalNumber(M, {
            unit: "day"
          });
        case "iii":
          return m.day(f, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return m.day(f, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return m.day(f, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return m.day(f, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(c, h, m) {
      var f = c.getUTCHours(), M = f / 12 >= 1 ? "pm" : "am";
      switch (h) {
        case "a":
        case "aa":
          return m.dayPeriod(M, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return m.dayPeriod(M, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return m.dayPeriod(M, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return m.dayPeriod(M, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(c, h, m) {
      var f = c.getUTCHours(), M;
      switch (f === 12 ? M = u.noon : f === 0 ? M = u.midnight : M = f / 12 >= 1 ? "pm" : "am", h) {
        case "b":
        case "bb":
          return m.dayPeriod(M, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return m.dayPeriod(M, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return m.dayPeriod(M, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return m.dayPeriod(M, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(c, h, m) {
      var f = c.getUTCHours(), M;
      switch (f >= 17 ? M = u.evening : f >= 12 ? M = u.afternoon : f >= 4 ? M = u.morning : M = u.night, h) {
        case "B":
        case "BB":
        case "BBB":
          return m.dayPeriod(M, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return m.dayPeriod(M, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return m.dayPeriod(M, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(c, h, m) {
      if (h === "ho") {
        var f = c.getUTCHours() % 12;
        return f === 0 && (f = 12), m.ordinalNumber(f, {
          unit: "hour"
        });
      }
      return l.default.h(c, h);
    },
    // Hour [0-23]
    H: function(c, h, m) {
      return h === "Ho" ? m.ordinalNumber(c.getUTCHours(), {
        unit: "hour"
      }) : l.default.H(c, h);
    },
    // Hour [0-11]
    K: function(c, h, m) {
      var f = c.getUTCHours() % 12;
      return h === "Ko" ? m.ordinalNumber(f, {
        unit: "hour"
      }) : (0, i.default)(f, h.length);
    },
    // Hour [1-24]
    k: function(c, h, m) {
      var f = c.getUTCHours();
      return f === 0 && (f = 24), h === "ko" ? m.ordinalNumber(f, {
        unit: "hour"
      }) : (0, i.default)(f, h.length);
    },
    // Minute
    m: function(c, h, m) {
      return h === "mo" ? m.ordinalNumber(c.getUTCMinutes(), {
        unit: "minute"
      }) : l.default.m(c, h);
    },
    // Second
    s: function(c, h, m) {
      return h === "so" ? m.ordinalNumber(c.getUTCSeconds(), {
        unit: "second"
      }) : l.default.s(c, h);
    },
    // Fraction of second
    S: function(c, h) {
      return l.default.S(c, h);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(c, h, m, f) {
      var M = f._originalDate || c, P = M.getTimezoneOffset();
      if (P === 0)
        return "Z";
      switch (h) {
        case "X":
          return g(P);
        case "XXXX":
        case "XX":
          return y(P);
        case "XXXXX":
        case "XXX":
        default:
          return y(P, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(c, h, m, f) {
      var M = f._originalDate || c, P = M.getTimezoneOffset();
      switch (h) {
        case "x":
          return g(P);
        case "xxxx":
        case "xx":
          return y(P);
        case "xxxxx":
        case "xxx":
        default:
          return y(P, ":");
      }
    },
    // Timezone (GMT)
    O: function(c, h, m, f) {
      var M = f._originalDate || c, P = M.getTimezoneOffset();
      switch (h) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + b(P, ":");
        case "OOOO":
        default:
          return "GMT" + y(P, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(c, h, m, f) {
      var M = f._originalDate || c, P = M.getTimezoneOffset();
      switch (h) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + b(P, ":");
        case "zzzz":
        default:
          return "GMT" + y(P, ":");
      }
    },
    // Seconds timestamp
    t: function(c, h, m, f) {
      var M = f._originalDate || c, P = Math.floor(M.getTime() / 1e3);
      return (0, i.default)(P, h.length);
    },
    // Milliseconds timestamp
    T: function(c, h, m, f) {
      var M = f._originalDate || c, P = M.getTime();
      return (0, i.default)(P, h.length);
    }
  };
  function b(p, c) {
    var h = p > 0 ? "-" : "+", m = Math.abs(p), f = Math.floor(m / 60), M = m % 60;
    if (M === 0)
      return h + String(f);
    var P = c || "";
    return h + String(f) + P + (0, i.default)(M, 2);
  }
  function g(p, c) {
    if (p % 60 === 0) {
      var h = p > 0 ? "-" : "+";
      return h + (0, i.default)(Math.abs(p) / 60, 2);
    }
    return y(p, c);
  }
  function y(p, c) {
    var h = c || "", m = p > 0 ? "-" : "+", f = Math.abs(p), M = (0, i.default)(Math.floor(f / 60), 2), P = (0, i.default)(f % 60, 2);
    return m + M + h + P;
  }
  var _ = v;
  e.default = _, t.exports = e.default;
})(ut, ut.exports);
var Ao = ut.exports, wt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = function(i, l) {
    switch (i) {
      case "P":
        return l.date({
          width: "short"
        });
      case "PP":
        return l.date({
          width: "medium"
        });
      case "PPP":
        return l.date({
          width: "long"
        });
      case "PPPP":
      default:
        return l.date({
          width: "full"
        });
    }
  }, r = function(i, l) {
    switch (i) {
      case "p":
        return l.time({
          width: "short"
        });
      case "pp":
        return l.time({
          width: "medium"
        });
      case "ppp":
        return l.time({
          width: "long"
        });
      case "pppp":
      default:
        return l.time({
          width: "full"
        });
    }
  }, n = function(i, l) {
    var u = i.match(/(P+)(p+)?/) || [], v = u[1], b = u[2];
    if (!b)
      return a(i, l);
    var g;
    switch (v) {
      case "P":
        g = l.dateTime({
          width: "short"
        });
        break;
      case "PP":
        g = l.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        g = l.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        g = l.dateTime({
          width: "full"
        });
        break;
    }
    return g.replace("{{date}}", a(v, l)).replace("{{time}}", r(b, l));
  }, o = {
    p: r,
    P: n
  }, d = o;
  e.default = d, t.exports = e.default;
})(wt, wt.exports);
var Ho = wt.exports, xt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    var n = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return n.setUTCFullYear(r.getFullYear()), r.getTime() - n.getTime();
  }
  t.exports = e.default;
})(xt, xt.exports);
var Ir = xt.exports;
const sr = /* @__PURE__ */ X(Ir);
var Ae = {};
Object.defineProperty(Ae, "__esModule", {
  value: !0
});
Ae.isProtectedDayOfYearToken = qo;
Ae.isProtectedWeekYearToken = Io;
Ae.throwProtectedError = Uo;
var Fo = ["D", "DD"], $o = ["YY", "YYYY"];
function qo(t) {
  return Fo.indexOf(t) !== -1;
}
function Io(t) {
  return $o.indexOf(t) !== -1;
}
function Uo(t, e, a) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Pt = { exports: {} }, Ct = { exports: {} }, Et = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Et, Et.exports);
var Le = Et.exports, kt = { exports: {} }, Dt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : r.defaultWidth, d = r.formats[o] || r.formats[r.defaultWidth];
      return d;
    };
  }
  t.exports = e.default;
})(Dt, Dt.exports);
var ee = Dt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(kt, kt.exports);
var Yo = kt.exports, Tt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Tt, Tt.exports);
var Oe = Tt.exports, Ot = { exports: {} }, Nt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function(n, o) {
      var d = o != null && o.context ? String(o.context) : "standalone", s;
      if (d === "formatting" && r.formattingValues) {
        var i = r.defaultFormattingWidth || r.defaultWidth, l = o != null && o.width ? String(o.width) : i;
        s = r.formattingValues[l] || r.formattingValues[i];
      } else {
        var u = r.defaultWidth, v = o != null && o.width ? String(o.width) : r.defaultWidth;
        s = r.values[v] || r.values[u];
      }
      var b = r.argumentCallback ? r.argumentCallback(n) : n;
      return s[b];
    };
  }
  t.exports = e.default;
})(Nt, Nt.exports);
var pe = Nt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, u = function(y, _) {
    var p = Number(y), c = p % 100;
    if (c > 20 || c < 10)
      switch (c % 10) {
        case 1:
          return p + "st";
        case 2:
          return p + "nd";
        case 3:
          return p + "rd";
      }
    return p + "th";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(Ot, Ot.exports);
var Ne = Ot.exports, St = { exports: {} }, jt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(o) {
    return function(d) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = s.width, l = i && o.matchPatterns[i] || o.matchPatterns[o.defaultMatchWidth], u = d.match(l);
      if (!u)
        return null;
      var v = u[0], b = i && o.parsePatterns[i] || o.parsePatterns[o.defaultParseWidth], g = Array.isArray(b) ? n(b, function(p) {
        return p.test(v);
      }) : r(b, function(p) {
        return p.test(v);
      }), y;
      y = o.valueCallback ? o.valueCallback(g) : g, y = s.valueCallback ? s.valueCallback(y) : y;
      var _ = d.slice(v.length);
      return {
        value: y,
        rest: _
      };
    };
  }
  function r(o, d) {
    for (var s in o)
      if (o.hasOwnProperty(s) && d(o[s]))
        return s;
  }
  function n(o, d) {
    for (var s = 0; s < o.length; s++)
      if (d(o[s]))
        return s;
  }
  t.exports = e.default;
})(jt, jt.exports);
var ge = jt.exports, Wt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = n.match(r.matchPattern);
      if (!d)
        return null;
      var s = d[0], i = n.match(r.parsePattern);
      if (!i)
        return null;
      var l = r.valueCallback ? r.valueCallback(i[0]) : i[0];
      l = o.valueCallback ? o.valueCallback(l) : l;
      var u = n.slice(s.length);
      return {
        value: l,
        rest: u
      };
    };
  }
  t.exports = e.default;
})(Wt, Wt.exports);
var ye = Wt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(th|st|nd|rd)?/i, d = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, i = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, y = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, _ = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(St, St.exports);
var Se = St.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(Yo), o = a(Oe), d = a(Ne), s = a(Se), i = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ct, Ct.exports);
var Ur = Ct.exports;
const Bo = /* @__PURE__ */ X(Ur);
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Ur), n = r.default;
  e.default = n, t.exports = e.default;
})(Pt, Pt.exports);
var Xo = Pt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = m;
  var r = a(Eo), n = a(To), o = a(he), d = a(Ao), s = a(Ho), i = a(Ir), l = Ae, u = a(De), v = a(K), b = Te, g = a(Xo), y = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, p = /^'([^]*?)'?$/, c = /''/g, h = /[a-zA-Z]/;
  function m(M, P, O) {
    var I, z, le, Ee, D, E, S, j, te, B, V, k, w, R, T, N, W, H;
    (0, v.default)(2, arguments);
    var J = String(P), Z = (0, b.getDefaultOptions)(), de = (I = (z = O == null ? void 0 : O.locale) !== null && z !== void 0 ? z : Z.locale) !== null && I !== void 0 ? I : g.default, be = (0, u.default)((le = (Ee = (D = (E = O == null ? void 0 : O.firstWeekContainsDate) !== null && E !== void 0 ? E : O == null || (S = O.locale) === null || S === void 0 || (j = S.options) === null || j === void 0 ? void 0 : j.firstWeekContainsDate) !== null && D !== void 0 ? D : Z.firstWeekContainsDate) !== null && Ee !== void 0 ? Ee : (te = Z.locale) === null || te === void 0 || (B = te.options) === null || B === void 0 ? void 0 : B.firstWeekContainsDate) !== null && le !== void 0 ? le : 1);
    if (!(be >= 1 && be <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ue = (0, u.default)((V = (k = (w = (R = O == null ? void 0 : O.weekStartsOn) !== null && R !== void 0 ? R : O == null || (T = O.locale) === null || T === void 0 || (N = T.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && w !== void 0 ? w : Z.weekStartsOn) !== null && k !== void 0 ? k : (W = Z.locale) === null || W === void 0 || (H = W.options) === null || H === void 0 ? void 0 : H.weekStartsOn) !== null && V !== void 0 ? V : 0);
    if (!(ue >= 0 && ue <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!de.localize)
      throw new RangeError("locale must contain localize property");
    if (!de.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var Q = (0, o.default)(M);
    if (!(0, r.default)(Q))
      throw new RangeError("Invalid time value");
    var fe = (0, i.default)(Q), ce = (0, n.default)(Q, fe), ve = {
      firstWeekContainsDate: be,
      weekStartsOn: ue,
      locale: de,
      _originalDate: Q
    }, q = J.match(_).map(function(A) {
      var U = A[0];
      if (U === "p" || U === "P") {
        var F = s.default[U];
        return F(A, de.formatLong);
      }
      return A;
    }).join("").match(y).map(function(A) {
      if (A === "''")
        return "'";
      var U = A[0];
      if (U === "'")
        return f(A);
      var F = d.default[U];
      if (F)
        return !(O != null && O.useAdditionalWeekYearTokens) && (0, l.isProtectedWeekYearToken)(A) && (0, l.throwProtectedError)(A, P, String(M)), !(O != null && O.useAdditionalDayOfYearTokens) && (0, l.isProtectedDayOfYearToken)(A) && (0, l.throwProtectedError)(A, P, String(M)), F(ce, A, de.localize, ve);
      if (U.match(h))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
      return A;
    }).join("");
    return q;
  }
  function f(M) {
    var P = M.match(p);
    return P ? P[1].replace(c, "'") : M;
  }
  t.exports = e.default;
})(at, at.exports);
var Vo = at.exports;
const Jo = /* @__PURE__ */ X(Vo);
function dr(t, e, a) {
  var r = Go(t, a.timeZone, a.locale);
  return r.formatToParts ? Qo(r, e) : Zo(r, e);
}
function Qo(t, e) {
  for (var a = t.formatToParts(e), r = a.length - 1; r >= 0; --r)
    if (a[r].type === "timeZoneName")
      return a[r].value;
}
function Zo(t, e) {
  var a = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(a);
  return r ? r[0].substr(1) : "";
}
function Go(t, e, a) {
  if (a && !a.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(a ? [a.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function Ko(t, e) {
  var a = ri(e);
  return a.formatToParts ? ti(a, t) : ai(a, t);
}
var ei = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function ti(t, e) {
  try {
    for (var a = t.formatToParts(e), r = [], n = 0; n < a.length; n++) {
      var o = ei[a[n].type];
      o >= 0 && (r[o] = parseInt(a[n].value, 10));
    }
    return r;
  } catch (d) {
    if (d instanceof RangeError)
      return [NaN];
    throw d;
  }
}
function ai(t, e) {
  var a = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Xe = {};
function ri(t) {
  if (!Xe[t]) {
    var e = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Xe[t] = a ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Xe[t];
}
function Yr(t, e, a, r, n, o, d) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, a), s.setUTCHours(r, n, o, d), s;
}
var lr = 36e5, ni = 6e4, Ve = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function er(t, e, a) {
  var r, n;
  if (!t || (r = Ve.timezoneZ.exec(t), r))
    return 0;
  var o;
  if (r = Ve.timezoneHH.exec(t), r)
    return o = parseInt(r[1], 10), ur(o) ? -(o * lr) : NaN;
  if (r = Ve.timezoneHHMM.exec(t), r) {
    o = parseInt(r[2], 10);
    var d = parseInt(r[3], 10);
    return ur(o, d) ? (n = Math.abs(o) * lr + d * ni, r[1] === "+" ? -n : n) : NaN;
  }
  if (si(t)) {
    e = new Date(e || Date.now());
    var s = a ? e : oi(e), i = Rt(s, t), l = a ? i : ii(e, i, t);
    return -l;
  }
  return NaN;
}
function oi(t) {
  return Yr(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function Rt(t, e) {
  var a = Ko(t, e), r = Yr(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), n = t.getTime(), o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, r - n;
}
function ii(t, e, a) {
  var r = t.getTime(), n = r - e, o = Rt(new Date(n), a);
  if (e === o)
    return e;
  n -= o - e;
  var d = Rt(new Date(n), a);
  return o === d ? o : Math.max(o, d);
}
function ur(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
var mr = {};
function si(t) {
  if (mr[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), mr[t] = !0, !0;
  } catch {
    return !1;
  }
}
var di = 60 * 1e3, li = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, a, r) {
    var n = Je(r.timeZone, t);
    if (n === 0)
      return "Z";
    switch (e) {
      case "X":
        return fr(n);
      case "XXXX":
      case "XX":
        return We(n);
      case "XXXXX":
      case "XXX":
      default:
        return We(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, a, r) {
    var n = Je(r.timeZone, t);
    switch (e) {
      case "x":
        return fr(n);
      case "xxxx":
      case "xx":
        return We(n);
      case "xxxxx":
      case "xxx":
      default:
        return We(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, a, r) {
    var n = Je(r.timeZone, t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ui(n, ":");
      case "OOOO":
      default:
        return "GMT" + We(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, a, r) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return dr("short", t, r);
      case "zzzz":
      default:
        return dr("long", t, r);
    }
  }
};
function Je(t, e) {
  var a = t ? er(t, e, !0) / di : e.getTimezoneOffset();
  if (Number.isNaN(a))
    throw new RangeError("Invalid time zone specified: " + t);
  return a;
}
function qe(t, e) {
  for (var a = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return a + r;
}
function We(t, e) {
  var a = e || "", r = t > 0 ? "-" : "+", n = Math.abs(t), o = qe(Math.floor(n / 60), 2), d = qe(Math.floor(n % 60), 2);
  return r + o + a + d;
}
function fr(t, e) {
  if (t % 60 === 0) {
    var a = t > 0 ? "-" : "+";
    return a + qe(Math.abs(t) / 60, 2);
  }
  return We(t, e);
}
function ui(t, e) {
  var a = t > 0 ? "-" : "+", r = Math.abs(t), n = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return a + String(n);
  var d = e || "";
  return a + String(n) + d + qe(o, 2);
}
const mi = li;
var fi = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Qe = 36e5, cr = 6e4, ci = 2, re = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: fi
};
function Br(t, e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = e || {}, r = a.additionalDigits == null ? ci : ko(a.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = vi(t), o = hi(n.date, r), d = o.year, s = o.restDateString, i = pi(s, d);
  if (isNaN(i))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    var l = i.getTime(), u = 0, v;
    if (n.time && (u = gi(n.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || a.timeZone) {
      if (v = er(n.timeZone || a.timeZone, new Date(l + u)), isNaN(v))
        return /* @__PURE__ */ new Date(NaN);
    } else
      v = sr(new Date(l + u)), v = sr(new Date(l + u + v));
    return new Date(l + u + v);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function vi(t) {
  var e = {}, a = re.dateTimePattern.exec(t), r;
  if (a ? (e.date = a[1], r = a[3]) : (a = re.datePattern.exec(t), a ? (e.date = a[1], r = a[2]) : (e.date = null, r = t)), r) {
    var n = re.timeZone.exec(r);
    n ? (e.time = r.replace(n[1], ""), e.timeZone = n[1].trim()) : e.time = r;
  }
  return e;
}
function hi(t, e) {
  var a = re.YYY[e], r = re.YYYYY[e], n;
  if (n = re.YYYY.exec(t) || r.exec(t), n) {
    var o = n[1];
    return {
      year: parseInt(o, 10),
      restDateString: t.slice(o.length)
    };
  }
  if (n = re.YY.exec(t) || a.exec(t), n) {
    var d = n[1];
    return {
      year: parseInt(d, 10) * 100,
      restDateString: t.slice(d.length)
    };
  }
  return {
    year: null
  };
}
function pi(t, e) {
  if (e === null)
    return null;
  var a, r, n, o;
  if (t.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  if (a = re.MM.exec(t), a)
    return r = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1, hr(e, n) ? (r.setUTCFullYear(e, n), r) : /* @__PURE__ */ new Date(NaN);
  if (a = re.DDD.exec(t), a) {
    r = /* @__PURE__ */ new Date(0);
    var d = parseInt(a[1], 10);
    return Mi(e, d) ? (r.setUTCFullYear(e, 0, d), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = re.MMDD.exec(t), a) {
    r = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1;
    var s = parseInt(a[2], 10);
    return hr(e, n, s) ? (r.setUTCFullYear(e, n, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = re.Www.exec(t), a)
    return o = parseInt(a[1], 10) - 1, pr(e, o) ? vr(e, o) : /* @__PURE__ */ new Date(NaN);
  if (a = re.WwwD.exec(t), a) {
    o = parseInt(a[1], 10) - 1;
    var i = parseInt(a[2], 10) - 1;
    return pr(e, o, i) ? vr(e, o, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function gi(t) {
  var e, a, r;
  if (e = re.HH.exec(t), e)
    return a = parseFloat(e[1].replace(",", ".")), Ze(a) ? a % 24 * Qe : NaN;
  if (e = re.HHMM.exec(t), e)
    return a = parseInt(e[1], 10), r = parseFloat(e[2].replace(",", ".")), Ze(a, r) ? a % 24 * Qe + r * cr : NaN;
  if (e = re.HHMMSS.exec(t), e) {
    a = parseInt(e[1], 10), r = parseInt(e[2], 10);
    var n = parseFloat(e[3].replace(",", "."));
    return Ze(a, r, n) ? a % 24 * Qe + r * cr + n * 1e3 : NaN;
  }
  return null;
}
function vr(t, e, a) {
  e = e || 0, a = a || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var n = r.getUTCDay() || 7, o = e * 7 + a + 1 - n;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var yi = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], bi = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Xr(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function hr(t, e, a) {
  if (e < 0 || e > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var r = Xr(t);
    if (r && a > bi[e] || !r && a > yi[e])
      return !1;
  }
  return !0;
}
function Mi(t, e) {
  if (e < 1)
    return !1;
  var a = Xr(t);
  return !(a && e > 366 || !a && e > 365);
}
function pr(t, e, a) {
  return !(e < 0 || e > 52 || a != null && (a < 0 || a > 6));
}
function Ze(t, e, a) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || a != null && (a < 0 || a >= 60));
}
var _i = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function wi(t, e, a) {
  var r = String(e), n = a || {}, o = r.match(_i);
  if (o) {
    var d = Br(n.originalDate || t, n);
    r = o.reduce(function(s, i) {
      if (i[0] === "'")
        return s;
      var l = s.indexOf(i), u = s[l - 1] === "'", v = s.replace(
        i,
        "'" + mi[i[0]](d, i, null, n) + "'"
      );
      return u ? v.substring(0, l - 1) + v.substring(l + 1) : v;
    }, r);
  }
  return Jo(t, r, n);
}
var Lt = { exports: {} }, zt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  function a(r, n) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    return r;
  }
  t.exports = e.default;
})(zt, zt.exports);
var xi = zt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var r = a(xi);
  function n(o) {
    return (0, r.default)({}, o);
  }
  t.exports = e.default;
})(Lt, Lt.exports);
var Pi = Lt.exports;
const Ci = /* @__PURE__ */ X(Pi);
function Ei(t, e, a) {
  var r = Br(t, a), n = er(e, r, !0), o = new Date(r.getTime() - n), d = /* @__PURE__ */ new Date(0);
  return d.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), d.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), d;
}
function ki(t, e, a, r) {
  var n = Ci(r);
  return n.timeZone = e, n.originalDate = t, wi(Ei(t, e), a, n);
}
var At = { exports: {} }, Ht = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "om " + l : l + " siden" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ht, Ht.exports);
var Di = Ht.exports, Ft = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Ft, Ft.exports);
var Ti = Ft.exports, $t = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})($t, $t.exports);
var Oi = $t.exports, qt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, u = function(y, _) {
    var p = Number(y);
    return p + ".";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(qt, qt.exports);
var Ni = qt.exports, It = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(\.)?/i, d = /\d+/i, s = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, i = {
    any: [/^f/i, /^(v|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, y = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, _ = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(It, It.exports);
var Si = It.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Di), n = a(Ti), o = a(Oi), d = a(Ni), s = a(Si), i = {
    code: "da",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(At, At.exports);
var ji = At.exports;
const Wi = /* @__PURE__ */ X(ji);
var Ut = { exports: {} }, Yt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, r = function(d, s, i) {
    var l, u = i != null && i.addSuffix ? a[d].withPreposition : a[d].standalone;
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : "vor " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Yt, Yt.exports);
var Ri = Yt.exports, Bt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Bt, Bt.exports);
var Li = Bt.exports, Xt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Xt, Xt.exports);
var zi = Xt.exports, Vt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, s = {
    narrow: d.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: d.wide
  }, i = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, l = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, u = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, v = function(_) {
    var p = Number(_);
    return p + ".";
  }, b = {
    ordinalNumber: v,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(_) {
        return _ - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      formattingValues: s,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, g = b;
  e.default = g, t.exports = e.default;
})(Vt, Vt.exports);
var Ai = Vt.exports, Jt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(\.)?/i, d = /\d+/i, s = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, i = {
    any: [/^v/i, /^n/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, y = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, _ = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, p = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(Jt, Jt.exports);
var Hi = Jt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Ri), n = a(Li), o = a(zi), d = a(Ai), s = a(Hi), i = {
    code: "de",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ut, Ut.exports);
var Fi = Ut.exports;
const $i = /* @__PURE__ */ X(Fi);
var Qt = { exports: {} }, Zt = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Zt, Zt.exports);
var qi = Zt.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(qi), o = a(Oe), d = a(Ne), s = a(Se), i = {
    code: "en-AU",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Qt, Qt.exports);
var Ii = Qt.exports;
const Ui = /* @__PURE__ */ X(Ii);
var Gt = { exports: {} }, Kt = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Kt, Kt.exports);
var Yi = Kt.exports, ea = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ea, ea.exports);
var Bi = ea.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Oe), n = a(Ne), o = a(Se), d = a(Yi), s = a(Bi), i = {
    code: "en-CA",
    formatDistance: d.default,
    formatLong: s.default,
    formatRelative: r.default,
    localize: n.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Gt, Gt.exports);
var Xi = Gt.exports;
const Vi = /* @__PURE__ */ X(Xi);
var ta = { exports: {} }, aa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(aa, aa.exports);
var Ji = aa.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(Oe), o = a(Ne), d = a(Se), s = a(Ji), i = {
    code: "en-GB",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: d.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(ta, ta.exports);
var Qi = ta.exports;
const Zi = /* @__PURE__ */ X(Qi);
var ra = { exports: {} }, na = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(na, na.exports);
var Gi = na.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(Oe), o = a(Ne), d = a(Se), s = a(Gi), i = {
    code: "en-IN",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: d.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(ra, ra.exports);
var Ki = ra.exports;
const es = /* @__PURE__ */ X(Ki);
var oa = { exports: {} }, ia = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ia, ia.exports);
var ts = ia.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(Oe), o = a(Ne), d = a(Se), s = a(ts), i = {
    code: "en-NZ",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: d.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(oa, oa.exports);
var as = oa.exports;
const rs = /* @__PURE__ */ X(as);
var sa = { exports: {} }, da = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(da, da.exports);
var ns = da.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Le), n = a(Oe), o = a(Ne), d = a(Se), s = a(ns), i = {
    code: "en-ZA",
    formatDistance: r.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: d.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(sa, sa.exports);
var os = sa.exports;
const is = /* @__PURE__ */ X(os);
var la = { exports: {} }, ua = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "en " + l : "hace " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(ua, ua.exports);
var ss = ua.exports, ma = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ma, ma.exports);
var ds = ma.exports, fa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, r = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(s, i, l, u) {
    return i.getUTCHours() !== 1 ? r[s] : a[s];
  }, o = n;
  e.default = o, t.exports = e.default;
})(fa, fa.exports);
var ls = fa.exports, ca = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, d = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, s = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, u = function(y, _) {
    var p = Number(y);
    return p + "º";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return Number(y) - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(ca, ca.exports);
var us = ca.exports, va = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ye), n = a(ge), o = /^(\d+)(º)?/i, d = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, b = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, g = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, y = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, _ = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, c = {
    ordinalNumber: (0, r.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(va, va.exports);
var ms = va.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ss), n = a(ds), o = a(ls), d = a(us), s = a(ms), i = {
    code: "es",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(la, la.exports);
var fs = la.exports;
const cs = /* @__PURE__ */ X(fs);
var ha = { exports: {} }, pa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "dans " + l : "il y a " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(pa, pa.exports);
var vs = pa.exports, ga = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ga, ga.exports);
var hs = ga.exports, ya = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})(ya, ya.exports);
var ps = ya.exports, ba = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, o = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, l = function(g, y) {
    var _ = Number(g), p = y == null ? void 0 : y.unit;
    if (_ === 0)
      return "0";
    var c = ["year", "week", "hour", "minute", "second"], h;
    return _ === 1 ? h = p && c.includes(p) ? "ère" : "er" : h = "ème", _ + h;
  }, u = {
    ordinalNumber: l,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(g) {
        return g - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, v = u;
  e.default = v, t.exports = e.default;
})(ba, ba.exports);
var gs = ba.exports, Ma = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(ième|ère|ème|er|e)?/i, d = /\d+/i, s = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, i = {
    any: [/^av/i, /^ap/i]
  }, l = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, y = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, _ = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(Ma, Ma.exports);
var ys = Ma.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(vs), n = a(hs), o = a(ps), d = a(gs), s = a(ys), i = {
    code: "fr",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(ha, ha.exports);
var bs = ha.exports;
const Ms = /* @__PURE__ */ X(bs);
var _a = { exports: {} }, wa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "tra " + l : l + " fa" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(wa, wa.exports);
var _s = wa.exports, xa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(xa, xa.exports);
var ws = xa.exports, Pa = { exports: {} }, Ca = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var r = a(K), n = a(Ue);
  function o(d, s, i) {
    (0, r.default)(2, arguments);
    var l = (0, n.default)(d, i), u = (0, n.default)(s, i);
    return l.getTime() === u.getTime();
  }
  t.exports = e.default;
})(Ca, Ca.exports);
var xs = Ca.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(xs), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function o(v) {
    switch (v) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[v] + " scorso alle' p";
    }
  }
  function d(v) {
    return "'" + n[v] + " alle' p";
  }
  function s(v) {
    switch (v) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[v] + " prossimo alle' p";
    }
  }
  var i = {
    lastWeek: function(b, g, y) {
      var _ = b.getUTCDay();
      return (0, r.default)(b, g, y) ? d(_) : o(_);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(b, g, y) {
      var _ = b.getUTCDay();
      return (0, r.default)(b, g, y) ? d(_) : s(_);
    },
    other: "P"
  }, l = function(b, g, y, _) {
    var p = i[b];
    return typeof p == "function" ? p(g, y, _) : p;
  }, u = l;
  e.default = u, t.exports = e.default;
})(Pa, Pa.exports);
var Ps = Pa.exports, Ea = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, d = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, i = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, l = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, u = function(y, _) {
    var p = Number(y);
    return String(p);
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(Ea, Ea.exports);
var Cs = Ea.exports, ka = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(º)?/i, d = /\d+/i, s = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, i = {
    any: [/^a/i, /^(d|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, b = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, y = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, _ = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(ka, ka.exports);
var Es = ka.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(_s), n = a(ws), o = a(Ps), d = a(Cs), s = a(Es), i = {
    code: "it",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(_a, _a.exports);
var ks = _a.exports;
const Ds = /* @__PURE__ */ X(ks);
var Da = { exports: {} }, Ta = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "over " + l : l + " geleden" : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ta, Ta.exports);
var Ts = Ta.exports, Oa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Oa, Oa.exports);
var Os = Oa.exports, Na = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Na, Na.exports);
var Ns = Na.exports, Sa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, l = function(g, y) {
    var _ = Number(g);
    return _ + "e";
  }, u = {
    ordinalNumber: l,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(g) {
        return g - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, v = u;
  e.default = v, t.exports = e.default;
})(Sa, Sa.exports);
var Ss = Sa.exports, ja = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)e?/i, d = /\d+/i, s = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, i = {
    any: [/^v/, /^n/]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, g = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, y = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, _ = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, p = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(ja, ja.exports);
var js = ja.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Ts), n = a(Os), o = a(Ns), d = a(Ss), s = a(js), i = {
    code: "nl",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Da, Da.exports);
var Ws = Da.exports;
const Rs = /* @__PURE__ */ X(Ws);
var Wa = { exports: {} }, Ra = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "daqui a " + l : "há " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ra, Ra.exports);
var Ls = Ra.exports, La = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(La, La.exports);
var zs = La.exports, za = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: function(d) {
      var s = d.getUTCDay(), i = s === 0 || s === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, r = function(d, s, i, l) {
    var u = a[d];
    return typeof u == "function" ? u(s) : u;
  }, n = r;
  e.default = n, t.exports = e.default;
})(za, za.exports);
var As = za.exports, Aa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, d = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, l = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, u = function(y, _) {
    var p = Number(y);
    return p + "º";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(Aa, Aa.exports);
var Hs = Aa.exports, Ha = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(º|ª)?/i, d = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, y = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, _ = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(Ha, Ha.exports);
var Fs = Ha.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Ls), n = a(zs), o = a(As), d = a(Hs), s = a(Fs), i = {
    code: "pt",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Wa, Wa.exports);
var $s = Wa.exports;
const qs = /* @__PURE__ */ X($s);
var Fa = { exports: {} }, $a = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, r = function(d, s, i) {
    var l, u = a[d];
    return typeof u == "string" ? l = u : s === 1 ? l = u.one : l = u.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "em " + l : "há " + l : l;
  }, n = r;
  e.default = n, t.exports = e.default;
})($a, $a.exports);
var Is = $a.exports, qa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(qa, qa.exports);
var Us = qa.exports, Ia = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: function(d) {
      var s = d.getUTCDay(), i = s === 0 || s === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, r = function(d, s, i, l) {
    var u = a[d];
    return typeof u == "function" ? u(s) : u;
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ia, Ia.exports);
var Ys = Ia.exports, Ua = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, d = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, u = function(y, _) {
    var p = Number(y);
    return (_ == null ? void 0 : _.unit) === "week" ? p + "ª" : p + "º";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(Ua, Ua.exports);
var Bs = Ua.exports, Ya = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)[ºªo]?/i, d = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, g = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, y = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, _ = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(Ya, Ya.exports);
var Xs = Ya.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Is), n = a(Us), o = a(Ys), d = a(Bs), s = a(Xs), i = {
    code: "pt-BR",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Fa, Fa.exports);
var Vs = Fa.exports;
const Js = /* @__PURE__ */ X(Vs);
var Ba = { exports: {} }, Xa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, r = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(s, i, l) {
    var u, v = a[s];
    return typeof v == "string" ? u = v : i === 1 ? u = v.one : l && l.onlyNumeric ? u = v.other.replace("{{count}}", String(i)) : u = v.other.replace("{{count}}", i < 13 ? r[i] : String(i)), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "om " + u : u + " sedan" : u;
  }, o = n;
  e.default = o, t.exports = e.default;
})(Xa, Xa.exports);
var Qs = Xa.exports, Va = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ee), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, o = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, d = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: d,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Va, Va.exports);
var Zs = Va.exports, Ja = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, r = function(d, s, i, l) {
    return a[d];
  }, n = r;
  e.default = n, t.exports = e.default;
})(Ja, Ja.exports);
var Gs = Ja.exports, Qa = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(pe), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, d = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, i = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, l = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, u = function(y, _) {
    var p = Number(y), c = p % 100;
    if (c > 20 || c < 10)
      switch (c % 10) {
        case 1:
        case 2:
          return p + ":a";
      }
    return p + ":e";
  }, v = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(y) {
        return y - 1;
      }
    }),
    month: (0, r.default)({
      values: d,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, b = v;
  e.default = b, t.exports = e.default;
})(Qa, Qa.exports);
var Ks = Qa.exports, Za = { exports: {} };
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(ge), n = a(ye), o = /^(\d+)(:a|:e)?/i, d = /\d+/i, s = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, i = {
    any: [/^f/i, /^[ev]/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, v = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, b = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, g = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, y = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, _ = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, p = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, c = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: d,
      valueCallback: function(f) {
        return parseInt(f, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(f) {
        return f + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: b,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: y,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: _,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = c;
  e.default = h, t.exports = e.default;
})(Za, Za.exports);
var ed = Za.exports;
(function(t, e) {
  var a = C.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = a(Qs), n = a(Zs), o = a(Gs), d = a(Ks), s = a(ed), i = {
    code: "sv",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: d.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ba, Ba.exports);
var td = Ba.exports;
const ad = /* @__PURE__ */ X(td), $ = {
  da: Wi,
  de: $i,
  enAU: Ui,
  enCA: Vi,
  enGB: Zi,
  enIN: es,
  enNZ: rs,
  enUS: Bo,
  enZA: is,
  es: cs,
  fr: Ms,
  it: Ds,
  nl: Rs,
  pt: qs,
  ptBR: Js,
  sv: ad
}, Ge = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: $.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: $.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: $.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: $.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: $.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: $.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: $.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: $.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: $.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: $.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: $.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Vr = (t, e) => t ? ki(
  t,
  Ge[e].dateProperties.timezone,
  Ge[e].dateProperties.format.timeDateFull,
  {
    locale: Ge[e].dateProperties.locale
  }
) : "", Jr = (t, e, a) => {
  a && a.startsWith("http") && (a = a.replace(/^http:/, "https:"));
  const r = a || "https://www.oddschecker.com", n = e.toLowerCase(), o = t.startsWith("/") ? t.slice(1) : t;
  return `${r}/${n}/${o}`;
}, rd = "_imageContainer_p8mnt_1", nd = "_overlay_p8mnt_18", od = "_focusTopLeft_p8mnt_36", id = "_focusTopCenter_p8mnt_40", sd = "_focusTopRight_p8mnt_44", dd = "_focusCenterLeft_p8mnt_48", ld = "_focusCenter_p8mnt_48", ud = "_focusCenterRight_p8mnt_56", md = "_focusBottomLeft_p8mnt_60", fd = "_focusBottomCenter_p8mnt_64", cd = "_focusBottomRight_p8mnt_68", vd = "_noOverlay_p8mnt_72", se = {
  imageContainer: rd,
  overlay: nd,
  focusTopLeft: od,
  focusTopCenter: id,
  focusTopRight: sd,
  focusCenterLeft: dd,
  focusCenter: ld,
  focusCenterRight: ud,
  focusBottomLeft: md,
  focusBottomCenter: fd,
  focusBottomRight: cd,
  noOverlay: vd
}, Qr = ({
  alt: t,
  focusArea: e = "CENTER",
  imageContainerClass: a = se.imageContainer,
  imageOverlayClass: r = se.overlay,
  showOverlay: n = !1,
  url: o
}) => /* @__PURE__ */ Y("div", { "aria-label": t, className: `${a} ${((s) => ({
  BOTTOM_CENTER: se.focusBottomCenter,
  BOTTOM_LEFT: se.focusBottomLeft,
  BOTTOM_RIGHT: se.focusBottomRight,
  CENTER: se.focusCenter,
  CENTER_LEFT: se.focusCenterLeft,
  CENTER_RIGHT: se.focusCenterRight,
  TOP_CENTER: se.focusTopCenter,
  TOP_LEFT: se.focusTopLeft,
  TOP_RIGHT: se.focusTopRight
})[s] || se.focusCenter)(e)}`, "data-testid": "article-image", children: [
  /* @__PURE__ */ x("img", { alt: t || "background image", src: o }),
  /* @__PURE__ */ x("div", { className: `${r} ${n ? "" : se.noOverlay}` })
] }), hd = "_lockBanner_pz94h_1", pd = {
  lockBanner: hd
};
function gd(t) {
  return /* @__PURE__ */ x(
    "svg",
    {
      fill: "none",
      height: "100%",
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 18 21",
      width: "18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ x(
        "path",
        {
          d: "M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z",
          stroke: "#00182E",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2"
        }
      )
    }
  );
}
const yd = ({ isLoggedIn: t }) => /* @__PURE__ */ x("div", { className: pd.lockBanner, children: t ? /* @__PURE__ */ x("span", { "data-testid": "unlocked-header", children: "unlocked" }) : /* @__PURE__ */ Y("span", { "data-testid": "locked-header", children: [
  /* @__PURE__ */ x(gd, {}),
  "log in to view for free"
] }) });
function bd(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(a) {
    return e[a] === void 0 && (e[a] = t(a)), e[a];
  };
}
var Md = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ke = /* @__PURE__ */ bd(
  function(t) {
    return Md.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), _d = function() {
  const e = Array.prototype.slice.call(arguments).filter(Boolean), a = {}, r = [];
  e.forEach((o) => {
    (o ? o.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, i] = s.split("_");
        a[i] = s;
      } else
        r.push(s);
    });
  });
  const n = [];
  for (const o in a)
    Object.prototype.hasOwnProperty.call(a, o) && n.push(a[o]);
  return n.push(...r), n.join(" ");
}, gr = _d, wd = (t) => t.toUpperCase() === t, xd = (t) => (e) => t.indexOf(e) === -1, Zr = (t, e) => {
  const a = {};
  return Object.keys(t).filter(xd(e)).forEach((r) => {
    a[r] = t[r];
  }), a;
};
function Pd(t, e, a) {
  const r = Zr(e, a);
  if (!t) {
    const n = typeof Ke == "function" ? { default: Ke } : Ke;
    Object.keys(r).forEach((o) => {
      n.default(o) || delete r[o];
    });
  }
  return r;
}
var Cd = (t, e) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof t == "number" && isFinite(t))
      return;
    const a = typeof t == "object" ? JSON.stringify(t) : String(t);
    console.warn(
      `An interpolation evaluated to '${a}' in the component '${e}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Ed = 0;
function yr(t) {
  let e = "";
  return process.env.NODE_ENV === "test" && (e += `mocked-styled-${Ed++}`, t && t.__wyw_meta && t.__wyw_meta.className && (e += ` ${t.__wyw_meta.className}`)), (a) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(a))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const r = (o, d) => {
      const { as: s = t, class: i = e } = o, l = a.propsAsIs === void 0 ? !(typeof s == "string" && s.indexOf("-") === -1 && !wd(s[0])) : a.propsAsIs, u = Pd(l, o, [
        "as",
        "class"
      ]);
      u.ref = d, u.className = a.atomic ? gr(a.class, u.className || i) : gr(u.className || i, a.class);
      const { vars: v } = a;
      if (v) {
        const b = {};
        for (const _ in v) {
          const p = v[_], c = p[0], h = p[1] || "", m = typeof c == "function" ? c(o) : c;
          Cd(m, a.name), b[`--${_}`] = `${m}${h}`;
        }
        const g = u.style || {}, y = Object.keys(g);
        y.length > 0 && y.forEach((_) => {
          b[_] = g[_];
        }), u.style = b;
      }
      return t.__wyw_meta && t !== s ? (u.as = s, _e(t, u)) : _e(s, u);
    }, n = ar ? ar(r) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const d = Zr(o, ["innerRef"]);
        return r(d, o.innerRef);
      }
    );
    return n.displayName = a.name, n.__wyw_meta = {
      className: a.class || e,
      extends: t
    }, n;
  };
}
var oe = process.env.NODE_ENV !== "production" ? new Proxy(yr, {
  get(t, e) {
    return t(e);
  }
}) : yr;
const kd = /* @__PURE__ */ oe("a")({
  name: "Item",
  class: "Item_iszlaff",
  propsAsIs: !1
}), Dd = /* @__PURE__ */ oe("div")({
  name: "TitleContainer",
  class: "TitleContainer_t153vcsb",
  propsAsIs: !1
}), Td = "imageContainer_i1ul0mop", Od = /* @__PURE__ */ oe("div")({
  name: "Title",
  class: "Title_t3rcaza",
  propsAsIs: !1
}), tr = /* @__PURE__ */ oe("div")({
  name: "Author",
  class: "Author_a12y2f5c",
  propsAsIs: !1
}), Nd = /* @__PURE__ */ oe("div")({
  name: "FlexWrapper",
  class: "FlexWrapper_f1svo7vk",
  propsAsIs: !1
}), Sd = () => tr, jd = /* @__PURE__ */ oe(Sd())({
  name: "PublishedDate",
  class: "PublishedDate_p10yfybh",
  propsAsIs: !0
}), Wd = () => tr, Rd = /* @__PURE__ */ oe(Wd())({
  name: "ReadTime",
  class: "ReadTime_reepqgx",
  propsAsIs: !0
}), Ld = /* @__PURE__ */ oe("p")({
  name: "Description",
  class: "Description_dckalez",
  propsAsIs: !1
}), zd = ({
  aiGeneratedId: t,
  authors: e = [],
  baseUrl: a,
  componentTags: r = [],
  description: n,
  image: o,
  isLoggedIn: d,
  publishedTime: s,
  readTime: i,
  repub: l,
  requestUrl: u,
  title: v,
  url: b
}) => {
  const g = () => {
    Tr({
      aiArticle: t ? "yes" : "no",
      articleName: v,
      event: Or.ARTICLE_CLICK,
      tipsterName: e[0].fullName
    });
  }, y = Vr(s, l), _ = r.includes("TIPS_PREMIUM"), p = Jr(b, l, a);
  return /* @__PURE__ */ Y("div", { children: [
    _ && /* @__PURE__ */ x(yd, { isLoggedIn: d }),
    /* @__PURE__ */ Y(kd, { "data-testid": "article-item", href: ze(p, u), onClick: g, children: [
      o && /* @__PURE__ */ x(
        Qr,
        {
          alt: o.alt,
          focusArea: o.focusArea,
          imageContainerClass: Td,
          url: Nr(o.url, 350)
        }
      ),
      /* @__PURE__ */ Y(Dd, { children: [
        /* @__PURE__ */ x(Od, { "data-testid": "article-title", children: v }),
        n && /* @__PURE__ */ x(Ld, { "data-testid": "article-description", children: n }),
        /* @__PURE__ */ Y(Nd, { children: [
          /* @__PURE__ */ Y("div", { children: [
            e.length && /* @__PURE__ */ x(tr, { "data-testid": "article-author", children: e[0].fullName }),
            s && /* @__PURE__ */ x(jd, { "data-testid": "article-published-time", children: y })
          ] }),
          /* @__PURE__ */ x("div", { children: i && /* @__PURE__ */ x(Rd, { "data-testid": "article-read-time", children: i }) })
        ] })
      ] })
    ] })
  ] });
}, Ad = "_wrapper_1h6cv_3", Hd = "_heroArticle_1h6cv_9", Fd = "_imageContainer_1h6cv_21", $d = "_contentContainer_1h6cv_37", qd = "_overlay_1h6cv_48", Id = "_title_1h6cv_59", Ud = "_metadata_1h6cv_68", Yd = "_metadataLeft_1h6cv_75", Bd = "_metadataRight_1h6cv_81", Xd = "_mobileTimestamp_1h6cv_87", Vd = "_desktopTimestamp_1h6cv_96", Jd = "_readTime_1h6cv_100", Qd = "_mobileAuthor_1h6cv_110", Zd = "_desktopAuthor_1h6cv_119", ie = {
  wrapper: Ad,
  heroArticle: Hd,
  imageContainer: Fd,
  contentContainer: $d,
  overlay: qd,
  title: Id,
  metadata: Ud,
  metadataLeft: Yd,
  metadataRight: Bd,
  mobileTimestamp: Xd,
  desktopTimestamp: Vd,
  readTime: Jd,
  mobileAuthor: Qd,
  desktopAuthor: Zd
}, Gd = ({
  authors: t = [],
  baseUrl: e,
  deviceType: a,
  image: r,
  publishedTime: n,
  readTime: o,
  repub: d,
  requestUrl: s,
  title: i,
  url: l
}) => {
  var p, c, h, m;
  const u = () => {
    Tr({
      articleName: i,
      event: Or.HERO_ARTICLE_VIEW,
      tipsterName: t[0].fullName
    });
  }, v = Vr(n, d), b = ((p = t[0]) == null ? void 0 : p.shortName) || ((c = t[0]) == null ? void 0 : c.fullName) || "", g = ((h = t[0]) == null ? void 0 : h.fullName) || ((m = t[0]) == null ? void 0 : m.shortName) || "", y = a === "MOBILE" ? 500 : a === "TABLET" ? 800 : 1e3, _ = Jr(l, d, e);
  return /* @__PURE__ */ x(
    "a",
    {
      className: ie.wrapper,
      "data-testid": "hero-article",
      href: ze(_, s),
      onClick: u,
      children: /* @__PURE__ */ Y("div", { className: ie.heroArticle, children: [
        /* @__PURE__ */ x(
          Qr,
          {
            alt: r.alt,
            focusArea: r.focusArea,
            imageContainerClass: ie.imageContainer,
            imageOverlayClass: ie.overlay,
            showOverlay: !0,
            url: Nr(r.url, y)
          }
        ),
        /* @__PURE__ */ Y("div", { className: ie.contentContainer, children: [
          /* @__PURE__ */ x("h2", { className: ie.title, "data-testid": "hero-article-title", children: i }),
          /* @__PURE__ */ Y("div", { className: ie.metadata, children: [
            /* @__PURE__ */ Y("div", { className: ie.metadataLeft, children: [
              /* @__PURE__ */ x("div", { className: ie.mobileAuthor, "data-testid": "hero-article-author-short-name", children: b }),
              /* @__PURE__ */ x("div", { className: ie.desktopAuthor, "data-testid": "hero-article-author-full-name", children: g }),
              /* @__PURE__ */ x("div", { className: ie.mobileTimestamp, "data-testid": "hero-article-publish-time", children: v })
            ] }),
            /* @__PURE__ */ Y("div", { className: ie.metadataRight, children: [
              /* @__PURE__ */ x("span", { className: ie.desktopTimestamp, "data-testid": "hero-article-publish-time-read-time", children: `${v} | ${o}` }),
              /* @__PURE__ */ x("span", { className: ie.readTime, "data-testid": "hero-article-read-time", children: o })
            ] })
          ] })
        ] })
      ] })
    }
  );
};
function Gr(t) {
  var e, a, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t)) {
      var n = t.length;
      for (e = 0; e < n; e++)
        t[e] && (a = Gr(t[e])) && (r && (r += " "), r += a);
    } else
      for (a in t)
        t[a] && (r && (r += " "), r += a);
  return r;
}
function Kd() {
  for (var t, e, a = 0, r = "", n = arguments.length; a < n; a++)
    (t = arguments[a]) && (e = Gr(t)) && (r && (r += " "), r += e);
  return r;
}
const el = "_up_77ag3_1", tl = "_down_77ag3_6", al = "_right_77ag3_11", rl = "_left_77ag3_16", nl = "_md_77ag3_21", ol = "_sm_77ag3_26", il = "_loading_77ag3_31", sl = "_light_77ag3_39", dl = "_dark_77ag3_42", br = {
  up: el,
  down: tl,
  right: al,
  left: rl,
  md: nl,
  sm: ol,
  loading: il,
  light: sl,
  dark: dl
}, ll = ({ variant: t }) => /* @__PURE__ */ x("span", { className: Kd(br.loading, br[t]), children: "" });
const ul = "pageLink_phpa8aq", ml = "paginationBreak_pcujydz", fl = "paginationBreakLink_pycfaqa", cl = "activePageLink_afjaptn", vl = /* @__PURE__ */ oe("div")({
  name: "Container",
  class: "Container_c7rub8e",
  propsAsIs: !1
}), hl = /* @__PURE__ */ oe("div")({
  name: "Header",
  class: "Header_hry9e47",
  propsAsIs: !1
}), pl = () => ({
  isHref: t
}) => t ? "underline" : "none", gl = /* @__PURE__ */ oe("a")({
  name: "HeadingLink",
  class: "HeadingLink_h1y3vfz9",
  propsAsIs: !1,
  vars: {
    "h1y3vfz9-0": [pl()]
  }
}), yl = () => ({
  isCentered: t
}) => t ? "center" : "flex-start", bl = /* @__PURE__ */ oe("div")({
  name: "Footer",
  class: "Footer_f1k2k5nt",
  propsAsIs: !1,
  vars: {
    "f1k2k5nt-0": [yl()]
  }
}), Ml = () => ({
  rows: t
}) => `repeat(${t}, auto)`, _l = /* @__PURE__ */ oe("div")({
  name: "ItemsContainer",
  class: "ItemsContainer_i1qes62j",
  propsAsIs: !1,
  vars: {
    "i1qes62j-0": [Ml()]
  }
}), wl = /* @__PURE__ */ oe("a")({
  name: "ArrowLink",
  class: "ArrowLink_aflq8vc",
  propsAsIs: !1
}), xl = /* @__PURE__ */ oe("button")({
  name: "LoadMoreButtonLink",
  class: "LoadMoreButtonLink_l102uha3",
  propsAsIs: !1
}), Pl = {
  FIRST_ARTICLE: "FIRST_ARTICLE",
  NONE: "NONE"
}, Cl = ({
  articles: t,
  articlesPage: e,
  baseUrl: a,
  defaultFeaturedArticle: r,
  deviceType: n,
  featuredArticleId: o,
  hasNextPage: d,
  isLoading: s,
  isLoggedIn: i,
  limit: l,
  loadMoreArticles: u,
  moreArticlesPath: v,
  moreArticlesText: b = "More Picks",
  pagination: g,
  paginationNextLabel: y,
  paginationPrevLabel: _,
  repub: p,
  requestUrl: c,
  title: h,
  total: m,
  type: f
}) => {
  const M = "oddschecker", P = Math.ceil(m / (l ?? 10)), O = (E) => {
    const S = E.selected + 1, j = new URL(window.location.href);
    S === 1 ? j.searchParams.delete("articlesPage") : j.searchParams.set("articlesPage", S.toString()), window.location.href = ze(j.toString());
  }, z = t.find((E) => E.id === o) || (r === Pl.FIRST_ARTICLE ? t[0] : null), le = z ? t.filter((E) => E.id !== z.id) : t, Ee = () => v ? /* @__PURE__ */ Y(wl, { "data-testid": "more-articles-link", href: ze(v, c), children: [
    b,
    /* @__PURE__ */ x("svg", { fill: "none", height: "10", viewBox: "0 0 11 10", width: "11", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ x(
      "path",
      {
        d: "M4.00003 0.757359L8.24267 5L4.00003 9.24264",
        stroke: "var(--cxy-color-interactive-secondary-subtle)",
        strokeWidth: "1.5"
      }
    ) })
  ] }) : null, D = () => d ? /* @__PURE__ */ x(xl, { "data-testid": "more-articles-link", disabled: s, onClick: u, children: s ? /* @__PURE__ */ x(ll, { variant: "light" }) : b }) : null;
  return /* @__PURE__ */ Y(vl, { "data-fpsm-theme": M, "data-testid": "more-articles", children: [
    z && /* @__PURE__ */ x(Gd, { ...z, baseUrl: a, deviceType: n, repub: p, requestUrl: c }),
    h && /* @__PURE__ */ x(hl, { children: /* @__PURE__ */ x(
      gl,
      {
        "data-testid": "more-articles-title",
        href: v ? ze(v, c) : void 0,
        isHref: !!v,
        title: h,
        children: h
      }
    ) }),
    /* @__PURE__ */ x(_l, { rows: t.length, children: le.map((E) => /* @__PURE__ */ _e(
      zd,
      {
        ...E,
        articleType: f,
        baseUrl: a,
        isLoggedIn: i,
        key: E.id,
        repub: p,
        requestUrl: c
      }
    )) }),
    g !== "NO_PAGINATION" && /* @__PURE__ */ Y(bl, { isCentered: !v, children: [
      g === "BOTTOM_PAGE_NUMBERS" && P > 1 && /* @__PURE__ */ x(
        Po,
        {
          activeLinkClassName: cl,
          breakClassName: ml,
          breakLabel: "...",
          breakLinkClassName: fl,
          forcePage: e - 1,
          hrefAllControls: !0,
          hrefBuilder: (E, S, j) => {
            if (E < 1 || E === j + 1)
              return;
            if (E === 1) {
              if (typeof window < "u") {
                const k = new URL(window.location.href);
                k.searchParams.delete("articlesPage");
                const w = k.searchParams.toString();
                return w ? `${k.pathname}?${w}` : k.pathname;
              }
              const B = new URL(c);
              B.searchParams.delete("articlesPage");
              const V = B.searchParams.toString();
              return V ? `${B.pathname}?${V}` : B.pathname;
            }
            if (typeof window < "u") {
              const B = new URL(window.location.href);
              return B.searchParams.set("articlesPage", String(E)), `${B.pathname}?${B.searchParams.toString()}`;
            }
            const te = new URL(c);
            return te.searchParams.set("articlesPage", String(E)), `${te.pathname}?${te.searchParams.toString()}`;
          },
          marginPagesDisplayed: 1,
          nextLabel: y,
          onPageChange: O,
          pageCount: P,
          pageLinkClassName: ul,
          pageRangeDisplayed: 1,
          previousLabel: _,
          selectedPageRel: null
        }
      ),
      g === "MORE_ARTICLES_LINKS" && v && /* @__PURE__ */ x(Ee, {}),
      g === "LOAD_MORE_BUTTON" && /* @__PURE__ */ x(D, {})
    ] })
  ] });
}, El = ({
  articlesPage: t,
  dataApiEndpoint: e,
  defaultFeaturedArticle: a,
  deviceType: r,
  featuredArticleId: n,
  isLoggedIn: o,
  moreArticlesPath: d,
  moreArticlesText: s,
  title: i,
  ...l
}) => {
  const [u, v] = Pr(100), b = Number.isFinite(t) && t > 0 ? t : 1, g = jr(l), { data: y, fetchNextPage: _, hasNextPage: p, isFetchingNextPage: c } = mn({
    getNextPageParam(f, M) {
      if (!(!f || f.length < l.limit))
        return M.length;
    },
    initialPageParam: b - 1,
    queryFn: async ({ pageParam: f }) => {
      const M = await Sr(
        e,
        {
          ...l,
          offset: f * l.limit
        },
        {
          logger: console
        }
      );
      return M ? (v(M.total), M.articles) : [];
    },
    queryKey: g,
    refetchOnMount: l.pagination === "BOTTOM_PAGE_NUMBERS" ? "always" : !1
    // this is to ensure that we get the articles total
  });
  if (!y || y.pages.flat().length === 0)
    return null;
  const m = y.pages.flat().filter((f) => f !== null);
  return /* @__PURE__ */ x(
    Cl,
    {
      articles: m,
      articlesPage: b,
      baseUrl: l.baseUrl,
      defaultFeaturedArticle: a,
      deviceType: r,
      featuredArticleId: n,
      hasNextPage: p,
      isLoading: c,
      isLoggedIn: o,
      limit: l.limit,
      loadMoreArticles: _,
      moreArticlesPath: d,
      moreArticlesText: s,
      offset: l.offset,
      pagination: l.pagination,
      repub: l.repub,
      requestUrl: l.requestUrl,
      title: i,
      total: u,
      type: l.type
    }
  );
};
var kl = /* @__PURE__ */ ((t) => (t.Insights = "INSIGHTS", t.Tips = "TIPS", t))(kl || {}), Dl = typeof Ce == "object" && Ce && Ce.Object === Object && Ce, Tl = typeof self == "object" && self && self.Object === Object && self, Ol = Dl || Tl || Function("return this")(), Mr = Ol.Symbol, _r = Mr ? Mr.prototype : void 0;
_r && _r.toString;
var Nl = typeof Ce == "object" && Ce && Ce.Object === Object && Ce, Sl = typeof self == "object" && self && self.Object === Object && self, jl = Nl || Sl || Function("return this")(), wr = jl.Symbol, xr = wr ? wr.prototype : void 0;
xr && xr.toString;
(function(t) {
  typeof globalThis != "object" && (this ? e() : (t.defineProperty(t.prototype, "_T_", {
    configurable: !0,
    get: e
  }), _T_));
  function e() {
    var a = this || self;
    a.globalThis = a, delete t.prototype._T_;
  }
})(Object);
const Wl = (t, e) => e.skipDedupe || e.method !== "GET", Rl = (t, e) => e.method + "@" + t, Ll = (t) => t.clone(), Kr = ({ skip: t = Wl, key: e = Rl, resolver: a = Ll } = {}) => {
  const r = /* @__PURE__ */ new Map();
  return (n) => (o, d) => {
    if (t(o, d))
      return n(o, d);
    const s = e(o, d);
    if (!r.has(s))
      r.set(s, []);
    else
      return new Promise((i, l) => {
        r.get(s).push([i, l]);
      });
    try {
      return n(o, d).then((i) => (r.get(s).forEach(([l]) => l(a(i))), r.delete(s), i)).catch((i) => {
        throw r.get(s).forEach(([, l]) => l(i)), r.delete(s), i;
      });
    } catch (i) {
      return r.delete(s), Promise.reject(i);
    }
  };
}, zl = (t, e) => e.skipCache || e.method !== "GET", Al = (t, e) => e.method + "@" + t, Hl = () => !1, Fl = () => null, $l = (t) => t.ok, ql = ({ throttle: t = 1e3, skip: e = zl, key: a = Al, clear: r = Hl, invalidate: n = Fl, condition: o = $l, flagResponseOnCacheHit: d = "__cached" } = {}) => {
  const s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), u = (b) => {
    t && !l.has(b) && (l.add(b), setTimeout(() => {
      l.delete(b);
    }, t));
  }, v = (b) => (g, y) => {
    const _ = a(g, y);
    let p = n(g, y);
    if (p && (p instanceof Array || (p = [p]), p.forEach((c) => {
      typeof c == "string" ? s.delete(c) : c instanceof RegExp && s.forEach((h, m) => {
        c.test(m) && s.delete(m);
      });
    })), r(g, y) && s.clear(), e(g, y))
      return b(g, y);
    if (l.has(_)) {
      if (s.has(_)) {
        const c = s.get(_).clone();
        return d && Object.defineProperty(c, d, {
          value: _,
          enumerable: !1
        }), Promise.resolve(c);
      } else if (i.has(_))
        return new Promise((c, h) => {
          i.get(_).push([c, h]);
        });
    }
    return i.has(_) || i.set(_, []), u(_), b(g, y).then((c) => (o(c.clone()) && s.set(_, c.clone()), i.get(_).forEach(([h]) => h(c.clone())), i.delete(_), c)).catch((c) => {
      throw i.get(_).forEach(([, h]) => h(c)), i.delete(_), c;
    });
  };
  return v.cacheResponse = function(b, g) {
    u(b), s.set(b, g);
  }, v.cache = s, v.inflight = i, v.throttling = l, v;
}, Il = (t, e) => t * e, Ul = (t) => t && t.ok, en = ({ delayTimer: t = 500, delayRamp: e = Il, maxAttempts: a = 10, until: r = Ul, onRetry: n = null, retryOnNetworkError: o = !1, resolveWithLatestResponse: d = !1, skip: s } = {}) => (i) => (l, u) => {
  let v = 0;
  if (s && s(l, u))
    return i(l, u);
  const b = (g, y) => Promise.resolve(r(g, y)).then((_) => _ ? g && d ? g : y ? Promise.reject(y) : g : (v++, !a || v <= a ? new Promise((p) => {
    const c = e(t, v);
    setTimeout(() => {
      typeof n == "function" ? Promise.resolve(n({
        response: g,
        error: y,
        url: l,
        options: u
      })).then((h = {}) => {
        var m, f;
        p(i((m = h && h.url) !== null && m !== void 0 ? m : l, (f = h && h.options) !== null && f !== void 0 ? f : u));
      }) : p(i(l, u));
    }, c);
  }).then(b).catch((p) => {
    if (!o)
      throw p;
    return b(null, p);
  }) : g && d ? g : Promise.reject(y || new Error("Number of attempts exceeded."))));
  return i(l, u).then(b).catch((g) => {
    if (!o)
      throw g;
    return b(null, g);
  });
};
we().middlewares([
  Kr(),
  en({
    delayRamp: (t, e) => t * e,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  ql({
    key: (t, e) => e.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
we().middlewares([
  Kr(),
  en({
    delayRamp: (t, e) => t * e,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function Yl(t = {}) {
  return new un.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(e) {
          return e * 100;
        }
      }
    },
    ...t
  });
}
const eu = async (t, e) => {
  const a = Yl(), r = Number.isFinite(t.articlesPage) && t.articlesPage > 0 ? t.articlesPage : 1, n = Math.max(0, (r - 1) * t.limit);
  let o = 0;
  try {
    const l = {
      countryCode: t.countryCode,
      limit: t.limit,
      offset: n,
      pagination: t.pagination,
      repub: t.repub,
      requestUrl: t.requestUrl,
      subdivision: t.subdivision,
      topics: t.topics,
      type: t.type
    };
    await a.prefetchInfiniteQuery({
      getNextPageParam(u, v) {
        if (!(!u || u.length < t.limit))
          return v.length;
      },
      initialPageParam: r - 1,
      queryFn: async ({ pageParam: u = 0 }) => {
        const v = await Sr(
          e,
          {
            ...l,
            offset: u * t.limit
          },
          { nocache: t.nocache }
        );
        return v && (o = v.total), v.articles;
      },
      queryKey: jr(l),
      staleTime: 1 / 0
    });
  } catch {
  }
  const d = fn(a), s = Math.ceil(o / t.limit), i = {
    articlesPerPage: t.limit,
    currentPage: r,
    hasNextPage: r < s,
    hasPrevPage: r > 1,
    totalArticles: o,
    totalPages: s
  };
  return {
    dehydratedState: d,
    paginationMeta: i
  };
}, Bl = (t) => new pn({
  defaultOptions: {
    queries: {
      gcTime: t ? 0 : void 0,
      refetchOnMount: !!t,
      retry: (e, a) => {
        var r;
        return ((r = a == null ? void 0 : a.response) == null ? void 0 : r.status) === 404 ? !1 : e < 2;
      },
      retryDelay: (e) => Math.min(1e3 * (e + 1), 3e3),
      staleTime: t ? 0 : 1 / 0
    }
  }
}), Xl = ({ resetErrorBoundary: t }) => (ln(() => {
  t();
}, [t]), null);
function tu({ dehydratedState: t, nocache: e, ...a }) {
  const [r] = Pr(() => {
    const n = Bl(e);
    return cn(n, t), n;
  });
  return /* @__PURE__ */ x(Dn, { children: /* @__PURE__ */ x(vn, { client: r, children: /* @__PURE__ */ x(hn, { children: ({ reset: n }) => /* @__PURE__ */ x(
    Mn,
    {
      fallbackRender: ({ resetErrorBoundary: o }) => /* @__PURE__ */ x(Xl, { resetErrorBoundary: o }),
      onReset: n,
      children: /* @__PURE__ */ x(Tn, { i18nInstance: a.i18n, children: /* @__PURE__ */ x(dn, { fallback: /* @__PURE__ */ x(Nn, {}), children: /* @__PURE__ */ x(El, { ...a }) }) })
    }
  ) }) }) });
}
export {
  kl as ArticleTypes,
  tu as MoreArticlesWithQuery,
  eu as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
